/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Map: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  QtyMap: { input: any; output: any; }
  StringMap: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type AddToProEventInput = {
  ageLimit: Scalars['Boolean']['input'];
  ageLimitNumber?: InputMaybe<Scalars['Int']['input']>;
  artistID?: InputMaybe<Scalars['ObjectID']['input']>;
  doorTime: Scalars['Time']['input'];
  hidden: Scalars['Boolean']['input'];
  venueID: Scalars['ObjectID']['input'];
};

export type AdditionalTermsAcceptance = {
  browserFingerprint: Scalars['String']['input'];
  eSignatureAdoptionTimestamp: Scalars['Time']['input'];
  ipAddress: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  termsAcceptanceTimestamp: Scalars['Time']['input'];
};

export type AddonCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  codeToUnlock?: InputMaybe<Array<Scalars['String']['input']>>;
  customFees?: InputMaybe<Array<UpsertCustomFeeInput>>;
  deductFees?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enteredAmount?: InputMaybe<Scalars['Int']['input']>;
  forcePurchaseWithTicket?: InputMaybe<Scalars['Boolean']['input']>;
  imageBase64?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isQuantityMinStrict?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantityMax?: InputMaybe<Scalars['Int']['input']>;
  quantityMin?: InputMaybe<Scalars['Int']['input']>;
  ticketPurchaseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  unlockWith?: InputMaybe<Scalars['QtyMap']['input']>;
  variations?: InputMaybe<Array<AddonVariationInput>>;
};

export type AddonCategoryObject = {
  __typename?: 'AddonCategoryObject';
  categoryId: Scalars['String']['output'];
  codeToUnlock?: Maybe<Array<Scalars['String']['output']>>;
  customFees?: Maybe<Array<CustomFeeObject>>;
  deductFees: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enteredAmount: Scalars['Int']['output'];
  eventId?: Maybe<Scalars['ObjectID']['output']>;
  forcePurchaseWithTicket: Scalars['Boolean']['output'];
  hashedUnlockCode?: Maybe<Array<Scalars['String']['output']>>;
  imageKey?: Maybe<Scalars['String']['output']>;
  isHidden: Scalars['Boolean']['output'];
  isQuantityMinStrict?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  quantityMax?: Maybe<Scalars['Int']['output']>;
  quantityMin?: Maybe<Scalars['Int']['output']>;
  sourceAddonCatId?: Maybe<Scalars['String']['output']>;
  ticketPurchaseRequired: Scalars['Boolean']['output'];
  unlockWith?: Maybe<Scalars['QtyMap']['output']>;
  variations?: Maybe<Array<AddonVariationObject>>;
};

export type AddonPurchase = {
  __typename?: 'AddonPurchase';
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  eventId: Scalars['ObjectID']['output'];
  holder: Attendee;
  id: Scalars['ObjectID']['output'];
  orderId: Scalars['ObjectID']['output'];
  redemptionTime?: Maybe<Scalars['Time']['output']>;
  refundDetails?: Maybe<RefundDetails>;
  transactions: ProductTransactions;
  unitCost: ProductUnitCost;
  variationId: Scalars['String']['output'];
};

export type AddonQuantityDistributed = {
  __typename?: 'AddonQuantityDistributed';
  distributed: Scalars['Int']['output'];
  inCart: Scalars['Int']['output'];
};

export type AddonVariationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enteredAmountDelta?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  quantityLimit?: InputMaybe<Scalars['Int']['input']>;
  variationId?: InputMaybe<Scalars['String']['input']>;
};

export type AddonVariationObject = {
  __typename?: 'AddonVariationObject';
  categoryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enteredAmountDelta: Scalars['Int']['output'];
  eventId?: Maybe<Scalars['ObjectID']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  purchases?: Maybe<Array<AddonPurchase>>;
  quantityDistributed: AddonQuantityDistributed;
  quantityLimit: Scalars['Int']['output'];
  unitPrice: Array<AddonVariationUnitPrice>;
  variationId: Scalars['String']['output'];
};

export type AddonVariationUnitPrice = {
  __typename?: 'AddonVariationUnitPrice';
  charge: Money;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  uniqueKey?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsObject = {
  __typename?: 'AnalyticsObject';
  date: Scalars['Time']['output'];
  hour: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type AnalyticsTotalsObject = {
  __typename?: 'AnalyticsTotalsObject';
  desktop: Scalars['Int']['output'];
  mobile: Scalars['Int']['output'];
  sevenDays: Scalars['Int']['output'];
  tablet: Scalars['Int']['output'];
  thirtyDays: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  twentyFourHours: Scalars['Int']['output'];
};

export type Artist = {
  __typename?: 'Artist';
  artistManagement?: Maybe<ArtistManagement>;
  artistMembers?: Maybe<ArtistMembers>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  frontEndGenres?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  imagePath?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  instagramHandle?: Maybe<Scalars['String']['output']>;
  internalGenres?: Maybe<Array<Scalars['String']['output']>>;
  itunes?: Maybe<Scalars['String']['output']>;
  merch?: Maybe<Scalars['String']['output']>;
  merchPath?: Maybe<Scalars['String']['output']>;
  mugshotImagePath?: Maybe<Scalars['String']['output']>;
  photographerLink?: Maybe<Scalars['String']['output']>;
  photographerName?: Maybe<Scalars['String']['output']>;
  similarArtists?: Maybe<Array<Artist>>;
  similarArtistsIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  slug?: Maybe<Scalars['String']['output']>;
  spotify?: Maybe<Scalars['String']['output']>;
  spotifyEmbed?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalArtistEvents?: Maybe<Scalars['Int']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
  youtubeEmbed?: Maybe<Scalars['String']['output']>;
};

export type ArtistId = {
  __typename?: 'ArtistId';
  artist?: Maybe<Scalars['String']['output']>;
};

export enum ArtistImageType {
  Banner = 'banner',
  Merch = 'merch',
  Mugshot = 'mugshot'
}

export type ArtistInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  frontEndGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  internalGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  itunes?: InputMaybe<Scalars['String']['input']>;
  merch?: InputMaybe<Scalars['String']['input']>;
  merchPath?: InputMaybe<Scalars['String']['input']>;
  mugshotImagePath?: InputMaybe<Scalars['String']['input']>;
  photographerLink?: InputMaybe<Scalars['String']['input']>;
  photographerName?: InputMaybe<Scalars['String']['input']>;
  similarArtistsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spotify?: InputMaybe<Scalars['String']['input']>;
  spotifyEmbed?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
  youtubeEmbed?: InputMaybe<Scalars['String']['input']>;
};

export type ArtistManagement = {
  __typename?: 'ArtistManagement';
  agency?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Scalars['String']['output']>;
  agentContact?: Maybe<Scalars['String']['output']>;
  artistId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Scalars['String']['output']>;
  managerContact?: Maybe<Scalars['String']['output']>;
};

export type ArtistManagementInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  agent?: InputMaybe<Scalars['String']['input']>;
  agentContact?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  managerContact?: InputMaybe<Scalars['String']['input']>;
};

export type ArtistMember = {
  __typename?: 'ArtistMember';
  email?: Maybe<Scalars['String']['output']>;
  memberRole?: Maybe<Scalars['String']['output']>;
  memberTags?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ArtistMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  memberRole?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ArtistMembers = {
  __typename?: 'ArtistMembers';
  artistId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<ArtistMember>>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type Attendee = {
  __typename?: 'Attendee';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
};

export type AttendingTicketObject = {
  __typename?: 'AttendingTicketObject';
  orderId?: Maybe<Scalars['String']['output']>;
  shortOrderId?: Maybe<Scalars['String']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
};

export enum BankAccountType {
  Chequing = 'chequing',
  Savings = 'savings'
}

export type BioSheet = {
  __typename?: 'BioSheet';
  altPlatforms?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  organizerClass?: Maybe<Scalars['String']['output']>;
  organizerId: Scalars['String']['output'];
  organizerName?: Maybe<Scalars['String']['output']>;
  organizerType?: Maybe<Scalars['String']['output']>;
  otherReferralSource?: Maybe<Scalars['String']['output']>;
  otherVenueName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  salesDetails?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
};

export type BsonSortInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type CalculateFeesResult = {
  __typename?: 'CalculateFeesResult';
  liability: Scalars['Int']['output'];
  processingFee: Scalars['Int']['output'];
  serviceFee: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
};

export type CancelEventInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  userIp?: InputMaybe<Scalars['String']['input']>;
};

export type CategorizedSalesData = {
  __typename?: 'CategorizedSalesData';
  categoryId?: Maybe<Scalars['String']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
};

export type CheckInOutput = {
  __typename?: 'CheckInOutput';
  scanCount: Scalars['Int']['output'];
  tickets: Array<Product>;
  totalCount: Scalars['Int']['output'];
};

export type CheckoutCustomField = {
  __typename?: 'CheckoutCustomField';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxLimit: Scalars['Int']['output'];
  minLimit: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type CheckoutCustomFieldInput = {
  label: Scalars['String']['input'];
  maxLimit?: Scalars['Int']['input'];
  minLimit?: Scalars['Int']['input'];
  required?: Scalars['Boolean']['input'];
  type?: Scalars['String']['input'];
};

export type CheckoutCustomFieldValue = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  clientRequestId: Scalars['String']['output'];
  sessionToken: Scalars['String']['output'];
};

export type CitySales = {
  __typename?: 'CitySales';
  city: Scalars['String']['output'];
  sales: Scalars['Int']['output'];
};

export type CloneEventInput = {
  seriesParentEventId?: InputMaybe<Scalars['String']['input']>;
  sourceEventId?: InputMaybe<Scalars['String']['input']>;
  targetDescription?: InputMaybe<Scalars['String']['input']>;
  targetEndDate?: InputMaybe<Scalars['Time']['input']>;
  targetStartDate?: InputMaybe<Scalars['Time']['input']>;
  targetTitle?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CoSponsor = {
  __typename?: 'CoSponsor';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CohostPermission {
  AccountInsights = 'accountInsights',
  AllEvents = 'allEvents',
  AuditReport = 'auditReport',
  DeleteEvent = 'deleteEvent',
  DraftEvent = 'draftEvent',
  EditEvent = 'editEvent',
  OrderListReport = 'orderListReport',
  PublishEvent = 'publishEvent',
  ScanLogReport = 'scanLogReport',
  ScanReport = 'scanReport',
  SearchAttendeeOrder = 'searchAttendeeOrder',
  SendCompTickets = 'sendCompTickets',
  SharedReport = 'sharedReport',
  TicketScan = 'ticketScan',
  TicketSell = 'ticketSell',
  UpcomingEvents = 'upcomingEvents',
  ViewOrders = 'viewOrders'
}

export type CreateArtistInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  frontEndGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  internalGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  itunes?: InputMaybe<Scalars['String']['input']>;
  management?: InputMaybe<ArtistManagementInput>;
  members?: InputMaybe<Array<InputMaybe<ArtistMemberInput>>>;
  merch?: InputMaybe<Scalars['String']['input']>;
  photographerLink?: InputMaybe<Scalars['String']['input']>;
  photographerName?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  spotify?: InputMaybe<Scalars['String']['input']>;
  spotifyEmbed?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
  youtubeEmbed?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientCreatedHoldInput = {
  eventId: Scalars['ObjectID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['QtyMap']['input'];
};

export type CreateCompOrderInput = {
  idempotencyKey: Scalars['String']['input'];
  profile: OrderProfileInput;
  purchases: OrderPurchaseInput;
};

export type CreateEventInput = {
  address?: InputMaybe<EventAddressInput>;
  captchaToken: Scalars['String']['input'];
  category?: InputMaybe<EventCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  enpid?: InputMaybe<Scalars['String']['input']>;
  eventGroupTag?: InputMaybe<Scalars['String']['input']>;
  eventImage?: InputMaybe<Scalars['String']['input']>;
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fbpid?: InputMaybe<Scalars['String']['input']>;
  ga4?: InputMaybe<Scalars['String']['input']>;
  ldpid?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  presentedBy?: InputMaybe<Scalars['Boolean']['input']>;
  presentedByName?: InputMaybe<Scalars['String']['input']>;
  recurringEvent?: InputMaybe<Scalars['Boolean']['input']>;
  referralCodes?: InputMaybe<Array<InputMaybe<ReferralCodeInput>>>;
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  scpid?: InputMaybe<Scalars['String']['input']>;
  spid?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  ttpid?: InputMaybe<Scalars['String']['input']>;
  twpid?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<EventVisibility>;
};

export type CreateExternalOrderInput = {
  idempotencyKey: Scalars['String']['input'];
  purchases: OrderPurchaseInput;
};

export type CreateGuestInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  totalCount: Scalars['Int']['input'];
};

export type CreateHoldInput = {
  additionalTermsData?: InputMaybe<AdditionalTermsAcceptance>;
  addons?: InputMaybe<Scalars['QtyMap']['input']>;
  charged: MoneyInput;
  customValues?: InputMaybe<Scalars['StringMap']['input']>;
  eventId: Scalars['ObjectID']['input'];
  fingerprint: Scalars['String']['input'];
  flexibleAmounts?: InputMaybe<Scalars['QtyMap']['input']>;
  promoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tickets: Scalars['QtyMap']['input'];
  tosAcceptanceDate?: InputMaybe<Scalars['Time']['input']>;
  unlockCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateInternalOrderInput = {
  hold: HoldInput;
  idempotencyKey: Scalars['String']['input'];
  paymentRequest?: InputMaybe<PaymentRequestInput>;
  profile: OrderProfileInput;
  referral?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMobileOrderInput = {
  idempotencyKey: Scalars['String']['input'];
  poiid: Scalars['String']['input'];
  purchases: OrderPurchaseInput;
};

export type CurrencyGlobalFees = {
  __typename?: 'CurrencyGlobalFees';
  processingFee: GlobalFeesData;
  serviceFee: GlobalFeesData;
};

export type CustomFeeObject = {
  __typename?: 'CustomFeeObject';
  amountCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  percentRate?: Maybe<Scalars['String']['output']>;
};

export type DailySalesDataObject = {
  __typename?: 'DailySalesDataObject';
  date?: Maybe<Scalars['Time']['output']>;
  hourlySalesData?: Maybe<Array<Maybe<HourlySalesDataObject>>>;
};

export type DataEvolutionObject = {
  __typename?: 'DataEvolutionObject';
  addonsCount: Scalars['Int']['output'];
  addonsLiability: Scalars['Int']['output'];
  ticketsCount: Scalars['Int']['output'];
  ticketsLiability: Scalars['Int']['output'];
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['Time']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
};

export enum DiscountType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export enum DonationsFilter {
  Only = 'only',
  With = 'with',
  Without = 'without'
}

export type EditClientCreatedHoldInput = {
  eventId: Scalars['ObjectID']['input'];
  holdId: Scalars['ObjectID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['QtyMap']['input'];
};

export type EntryTimeFilter = {
  from?: InputMaybe<Scalars['Time']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
};

export type EventAddress = {
  __typename?: 'EventAddress';
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<EventAddressLocation>;
  privateLocation?: Maybe<Scalars['Boolean']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type EventAddressInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<EventAddressLocationInput>;
  privateLocation?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type EventAddressLocation = {
  __typename?: 'EventAddressLocation';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  locationType?: Maybe<Scalars['String']['output']>;
};

export type EventAddressLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  locationType?: InputMaybe<Scalars['String']['input']>;
};

export type EventCancellationOutput = {
  __typename?: 'EventCancellationOutput';
  event?: Maybe<EventObject>;
  refundableOrdersCount: Scalars['Int']['output'];
  refundedOrdersCount: Scalars['Int']['output'];
  voidableOrdersCount: Scalars['Int']['output'];
  voidedOrdersCount: Scalars['Int']['output'];
};

export enum EventCategory {
  ArtsAndCulture = 'ARTS_AND_CULTURE',
  AwardShow = 'AWARD_SHOW',
  CarnivalOrFair = 'CARNIVAL_OR_FAIR',
  ClassTrainingOrInfoSession = 'CLASS_TRAINING_OR_INFO_SESSION',
  Comedy = 'COMEDY',
  Conference = 'CONFERENCE',
  Crafting = 'CRAFTING',
  FashionShow = 'FASHION_SHOW',
  Festival = 'FESTIVAL',
  Fitness = 'FITNESS',
  FoodAndDrink = 'FOOD_AND_DRINK',
  FundraiserOrCharity = 'FUNDRAISER_OR_CHARITY',
  Music = 'MUSIC',
  Other = 'OTHER',
  Party = 'PARTY',
  Performance = 'PERFORMANCE',
  Sports = 'SPORTS',
  Tech = 'TECH',
  TradeShow = 'TRADE_SHOW'
}

export enum EventCity {
  Calgary = 'Calgary',
  Edmonton = 'Edmonton',
  Halifax = 'Halifax',
  Hamilton = 'Hamilton',
  Kelowna = 'Kelowna',
  London = 'London',
  Montreal = 'Montreal',
  Ottawa = 'Ottawa',
  Toronto = 'Toronto',
  Vancouver = 'Vancouver',
  Victoria = 'Victoria'
}

export type EventCohostObject = {
  __typename?: 'EventCohostObject';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<CohostPermission>>>;
};

export type EventFeesObject = {
  __typename?: 'EventFeesObject';
  processingPercentFee: Scalars['String']['output'];
  serviceFlatFee: Scalars['Int']['output'];
  servicePercentFee: Scalars['String']['output'];
};

export type EventFeesRangeObject = {
  __typename?: 'EventFeesRangeObject';
  hasLockedCategoryWithInventory?: Maybe<Scalars['Boolean']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  soldOut?: Maybe<Scalars['Boolean']['output']>;
};

export type EventGroup = {
  __typename?: 'EventGroup';
  associatedEventIds: Array<Scalars['ObjectID']['output']>;
  associatedEvents?: Maybe<Array<EventObject>>;
  description: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  mainEventIds: Array<Scalars['ObjectID']['output']>;
  mainEvents?: Maybe<Array<EventObject>>;
};

export type EventGroupInput = {
  associatedEventIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  mainEventIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};

export type EventInput = {
  additionalTerms?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<EventAddressInput>;
  category?: InputMaybe<EventCategory>;
  checkoutCustomFields?: InputMaybe<Array<CheckoutCustomFieldInput>>;
  currency?: InputMaybe<PaymentCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  enpid?: InputMaybe<Scalars['String']['input']>;
  eventCapacity?: InputMaybe<Scalars['Int']['input']>;
  eventGroupTag?: InputMaybe<Scalars['String']['input']>;
  eventImage?: InputMaybe<Scalars['String']['input']>;
  eventTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fbpid?: InputMaybe<Scalars['String']['input']>;
  ga4?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ldpid?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  postCheckoutCta?: InputMaybe<PostCheckoutCtaInput>;
  presentedBy?: InputMaybe<Scalars['Boolean']['input']>;
  presentedByName?: InputMaybe<Scalars['String']['input']>;
  promoCodes?: InputMaybe<Array<InputMaybe<PromoCodeInput>>>;
  publishDate?: InputMaybe<Scalars['Time']['input']>;
  referralCodes?: InputMaybe<Array<InputMaybe<ReferralCodeInput>>>;
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
  scpid?: InputMaybe<Scalars['String']['input']>;
  seriesSchedule?: InputMaybe<SeriesScheduleInput>;
  spid?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<EventStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  ttpid?: InputMaybe<Scalars['String']['input']>;
  twpid?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<EventVisibility>;
};

export enum EventLocation {
  InPerson = 'inPerson',
  Online = 'online'
}

export type EventObject = {
  __typename?: 'EventObject';
  additionalFees: EventFeesObject;
  additionalTerms?: Maybe<Scalars['String']['output']>;
  addonCategories?: Maybe<Array<AddonCategoryObject>>;
  address?: Maybe<EventAddress>;
  attendingTickets?: Maybe<Array<Maybe<AttendingTicketObject>>>;
  canAddQuestions?: Maybe<Scalars['Boolean']['output']>;
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canInviteCohosts?: Maybe<Scalars['Boolean']['output']>;
  canMessage?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<EventCategory>;
  checkoutCustomFields?: Maybe<Array<CheckoutCustomField>>;
  checkoutPromoCodes?: Maybe<Array<Maybe<PromoCode>>>;
  coSponsors?: Maybe<Array<CoSponsor>>;
  cohosts?: Maybe<Array<Maybe<EventCohostObject>>>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  currency: Scalars['String']['output'];
  customFees?: Maybe<Array<Maybe<CustomFeeObject>>>;
  dailySalesData?: Maybe<Array<Maybe<DailySalesDataObject>>>;
  dataEvolution?: Maybe<DataEvolutionObject>;
  description?: Maybe<Scalars['String']['output']>;
  embeddedImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endDate?: Maybe<Scalars['Time']['output']>;
  enpid?: Maybe<Scalars['String']['output']>;
  eventCapacity?: Maybe<Scalars['Int']['output']>;
  eventFinancialReport?: Maybe<ReportData>;
  eventGroupTag?: Maybe<Scalars['String']['output']>;
  eventImage?: Maybe<Scalars['String']['output']>;
  eventOrganizerDisplayName?: Maybe<Scalars['String']['output']>;
  eventTags?: Maybe<Array<Scalars['String']['output']>>;
  eventType?: Maybe<Scalars['String']['output']>;
  fbpid?: Maybe<Scalars['String']['output']>;
  feesGroups?: Maybe<Array<FeesGroupObject>>;
  feesRange?: Maybe<EventFeesRangeObject>;
  ga4?: Maybe<Scalars['String']['output']>;
  guests?: Maybe<Array<Guest>>;
  holds?: Maybe<Array<HoldObject>>;
  id: Scalars['String']['output'];
  imageUploadUrl?: Maybe<UploadEventImageObject>;
  inviteList?: Maybe<Array<Maybe<InviteList>>>;
  isArchivable?: Maybe<Scalars['Boolean']['output']>;
  isCancellable?: Maybe<Scalars['Boolean']['output']>;
  isDeletable?: Maybe<Scalars['Boolean']['output']>;
  isPostponable?: Maybe<Scalars['Boolean']['output']>;
  isTicketPrintable?: Maybe<Scalars['Boolean']['output']>;
  ldpid?: Maybe<Scalars['String']['output']>;
  liabilityTotal?: Maybe<Scalars['Float']['output']>;
  myPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  organizer?: Maybe<UserObject>;
  organizerColor?: Maybe<Scalars['String']['output']>;
  organizerId?: Maybe<Scalars['String']['output']>;
  organizerType?: Maybe<UserType>;
  overrideDateRange?: Maybe<Scalars['String']['output']>;
  overridePriceRange?: Maybe<Scalars['String']['output']>;
  peakScanTime?: Maybe<PeakScanTimeObject>;
  place?: Maybe<Scalars['String']['output']>;
  postCheckoutCta?: Maybe<PostCheckoutCta>;
  presentedBy?: Maybe<Scalars['Boolean']['output']>;
  presentedByName?: Maybe<Scalars['String']['output']>;
  promoCodes?: Maybe<Array<Maybe<PromoCode>>>;
  publishDate?: Maybe<Scalars['Time']['output']>;
  questionnaire?: Maybe<Questionnaire>;
  recurringEvents?: Maybe<Array<EventObject>>;
  referralCodes?: Maybe<Array<Maybe<ReferralCode>>>;
  replyToEmail?: Maybe<Scalars['String']['output']>;
  requirePurchaserAddress: Scalars['Boolean']['output'];
  scanCount?: Maybe<ScanCountWithActiveObject>;
  scanLog?: Maybe<PaginatedScanLog>;
  scanWithEvents?: Maybe<Array<EventObject>>;
  scpid?: Maybe<Scalars['String']['output']>;
  seriesParentEventId?: Maybe<Scalars['String']['output']>;
  seriesSchedule?: Maybe<SeriesScheduleObject>;
  shortEventId?: Maybe<Scalars['String']['output']>;
  sourceEventId?: Maybe<Scalars['String']['output']>;
  spid?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Time']['output']>;
  status: EventStatus;
  suspension?: Maybe<EventSuspension>;
  ticketCategories?: Maybe<Array<Maybe<TicketCategoryObject>>>;
  tickets?: Maybe<PaginatedProducts>;
  timeSlots?: Maybe<Array<EventTimeSlot>>;
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  ttpid?: Maybe<Scalars['String']['output']>;
  twpid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  videoEmbedUrl?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<EventVisibility>;
  waitlist?: Maybe<Array<Maybe<Waitlist>>>;
  waitlistEnabled: Scalars['Boolean']['output'];
};


export type EventObjectAdditionalFeesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


export type EventObjectCustomFeesArgs = {
  globalOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EventObjectDailySalesDataArgs = {
  donationsFilter?: DonationsFilter;
};


export type EventObjectDataEvolutionArgs = {
  daysSince?: Scalars['Int']['input'];
  donationsFilter?: DonationsFilter;
};


export type EventObjectGuestsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type EventObjectHoldsArgs = {
  clientCreatedOnly?: Scalars['Boolean']['input'];
};


export type EventObjectReferralCodesArgs = {
  donationsFilter?: DonationsFilter;
};


export type EventObjectScanLogArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type EventObjectTicketCategoriesArgs = {
  donationsFilter?: DonationsFilter;
};


export type EventObjectTicketsArgs = {
  donationsFilter?: DonationsFilter;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type EventObjectTimeSlotsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};

export enum EventRestriction {
  AllEvents = 'allEvents',
  EndedOnly = 'endedOnly',
  LiveOnly = 'liveOnly'
}

export enum EventStatus {
  Archived = 'Archived',
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Postponed = 'Postponed',
  Published = 'Published'
}

export type EventSuspension = {
  __typename?: 'EventSuspension';
  indefinite?: Maybe<Scalars['Boolean']['output']>;
};

export type EventTimeSlot = {
  __typename?: 'EventTimeSlot';
  categories: Array<EventTimeSlotCategory>;
  description: Scalars['String']['output'];
  endTime: Scalars['Time']['output'];
  liability: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  startTime: Scalars['Time']['output'];
};

export type EventTimeSlotCategory = {
  __typename?: 'EventTimeSlotCategory';
  categoryId: Scalars['String']['output'];
  liability: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sold: Scalars['Int']['output'];
};

export enum EventVisibility {
  Private = 'private',
  Public = 'public'
}

export type EventsOverviewInput = {
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: Array<EventLocation>;
  orderBy?: InputMaybe<BsonSortInput>;
  restriction?: InputMaybe<EventRestriction>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  startDateRange?: InputMaybe<DateRangeInput>;
  status?: Array<EventStatus>;
  take?: Scalars['Int']['input'];
};

export type Fee = {
  __typename?: 'Fee';
  charge?: Maybe<Money>;
  order: Scalars['Int']['output'];
};

export type FeeItem = {
  __typename?: 'FeeItem';
  amount: Scalars['Int']['output'];
  feeId: Scalars['String']['output'];
  feeName: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
};

export type FeesGroupInput = {
  feeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
};

export type FeesGroupObject = {
  __typename?: 'FeesGroupObject';
  feeIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
};

export type FlexiblePricingInput = {
  isDonation?: InputMaybe<Scalars['Boolean']['input']>;
  maxAmount?: InputMaybe<Scalars['Int']['input']>;
  minAmount?: InputMaybe<Scalars['Int']['input']>;
  steps?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FlexiblePricingObject = {
  __typename?: 'FlexiblePricingObject';
  isDonation: Scalars['Boolean']['output'];
  maxAmount: Scalars['Int']['output'];
  minAmount: Scalars['Int']['output'];
  steps?: Maybe<Array<Scalars['Int']['output']>>;
};

export type FollowupQuestion = {
  __typename?: 'FollowupQuestion';
  isRequired: Scalars['Boolean']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FollowupQuestionInput = {
  isRequired: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
  ticketType: Scalars['String']['input'];
  type: QuestionType;
};

export type Genre = {
  __typename?: 'Genre';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GeolocationPoints = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type GlobalFees = {
  __typename?: 'GlobalFees';
  CAD: CurrencyGlobalFees;
  USD: CurrencyGlobalFees;
};

export type GlobalFeesData = {
  __typename?: 'GlobalFeesData';
  flat: Scalars['Int']['output'];
  percent: Scalars['String']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  checkedInCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GuestInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
};

export type HoldInput = {
  fingerprint: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type HoldObject = {
  __typename?: 'HoldObject';
  addonsQty?: Maybe<Scalars['QtyMap']['output']>;
  customValues?: Maybe<Scalars['StringMap']['output']>;
  expiresAt: Scalars['Time']['output'];
  id: Scalars['ObjectID']['output'];
  isClientCreated: Scalars['Boolean']['output'];
  ticketsQty?: Maybe<Scalars['QtyMap']['output']>;
};

export type HoldOutput = {
  __typename?: 'HoldOutput';
  expiresAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
};

export type HourlySalesDataObject = {
  __typename?: 'HourlySalesDataObject';
  categorizedSales?: Maybe<Array<Maybe<CategorizedSalesData>>>;
  hour?: Maybe<Scalars['Int']['output']>;
};

export type InviteList = {
  __typename?: 'InviteList';
  email?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LocationPoints = {
  latitude?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Int']['input']>;
};

export type MetaCategory = {
  __typename?: 'MetaCategory';
  categoryId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refs?: Maybe<Array<Maybe<MetaCategoryRef>>>;
};

export type MetaCategoryRef = {
  __typename?: 'MetaCategoryRef';
  categoryId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
};

export type MoneyInput = {
  amount: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
};

export type MonthlyOptionsInput = {
  calendarDay?: InputMaybe<Scalars['Int']['input']>;
  weekDay?: InputMaybe<Scalars['String']['input']>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type MonthlyOptionsObject = {
  __typename?: 'MonthlyOptionsObject';
  calendarDay?: Maybe<Scalars['Int']['output']>;
  weekDay?: Maybe<Scalars['String']['output']>;
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addEventEmbeddedImage?: Maybe<Array<Scalars['String']['output']>>;
  addGalleryImage?: Maybe<Array<Scalars['String']['output']>>;
  addGuests?: Maybe<Array<Guest>>;
  addInvites?: Maybe<EventObject>;
  addNewVenue?: Maybe<Scalars['String']['output']>;
  addOrganizerNote?: Maybe<OrganizerNote>;
  addProEventImage?: Maybe<Scalars['String']['output']>;
  addPromoCode?: Maybe<OrganizerPromoCode>;
  addTallBannerImage?: Maybe<Scalars['String']['output']>;
  addToProEvents: Scalars['Boolean']['output'];
  addToWaitlist?: Maybe<EventObject>;
  addUserImage?: Maybe<Scalars['String']['output']>;
  cancelEvent?: Maybe<EventCancellationOutput>;
  changeGuest?: Maybe<Guest>;
  changeUserRole?: Maybe<UserObject>;
  changeUserType?: Maybe<UserObject>;
  checkInGuest?: Maybe<Guest>;
  checkInOrder: Scalars['Boolean']['output'];
  checkInTicket?: Maybe<TicketCheckInOutput>;
  checkOutOrder: Scalars['Boolean']['output'];
  checkOutTicket?: Maybe<TicketCheckInOutput>;
  continueSignUp: Scalars['Boolean']['output'];
  createArtist?: Maybe<Artist>;
  createCheckoutSession?: Maybe<CheckoutSession>;
  createClientCreatedHold?: Maybe<HoldObject>;
  createCompOrder?: Maybe<Scalars['String']['output']>;
  createEvent?: Maybe<EventObject>;
  createExternalOrder?: Maybe<Order>;
  createHold?: Maybe<HoldOutput>;
  createInternalOrder?: Maybe<Scalars['String']['output']>;
  createMobileOrder?: Maybe<Order>;
  createUser: Scalars['Boolean']['output'];
  deactivateMe?: Maybe<Scalars['Boolean']['output']>;
  deleteAddonCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteArtist?: Maybe<Scalars['Boolean']['output']>;
  deleteEvent?: Maybe<Scalars['Boolean']['output']>;
  deleteEventGroup: Scalars['Boolean']['output'];
  deleteHold: Scalars['Boolean']['output'];
  deleteOrganizerNote: Scalars['Boolean']['output'];
  deletePromoCode?: Maybe<Scalars['Boolean']['output']>;
  deleteSeriesSchedule: Scalars['Boolean']['output'];
  deleteTicketCategory?: Maybe<Scalars['Boolean']['output']>;
  downloadAdditionalTerms?: Maybe<Scalars['String']['output']>;
  downloadAdditionalTermsAtConfirmation?: Maybe<Scalars['String']['output']>;
  downloadTickets?: Maybe<Scalars['String']['output']>;
  downloadTicketsAtConfirmation?: Maybe<Scalars['String']['output']>;
  duplicateAddonCategory?: Maybe<AddonCategoryObject>;
  duplicateEvent?: Maybe<EventObject>;
  duplicateTicketCategory?: Maybe<TicketCategoryObject>;
  editClientCreatedHold?: Maybe<HoldObject>;
  editOrderEmail: Scalars['Boolean']['output'];
  editOrderNote?: Maybe<Order>;
  editOrderPurchaser?: Maybe<Order>;
  enableWaitlist: Scalars['Boolean']['output'];
  eventImageUpload?: Maybe<Scalars['String']['output']>;
  eventScanOutAll: Scalars['Boolean']['output'];
  importCompanyEvents: Scalars['Boolean']['output'];
  importNuTicketCompanies: Scalars['Boolean']['output'];
  importSellerEvents: Scalars['Boolean']['output'];
  messageEventAttendees?: Maybe<Scalars['Int']['output']>;
  myOrganizedEventsOverview?: Maybe<PaginatedEvents>;
  ping: Scalars['String']['output'];
  redeemAddonPurchase?: Maybe<AddonPurchase>;
  refundOrder: Scalars['Boolean']['output'];
  removeCoSponsor?: Maybe<EventObject>;
  removeCohost?: Maybe<EventObject>;
  removeEventEmbeddedImage?: Maybe<Array<Scalars['String']['output']>>;
  removeGalleryImage?: Maybe<Array<Scalars['String']['output']>>;
  removeGuest: Scalars['Boolean']['output'];
  removePaymentSettings?: Maybe<Scalars['Boolean']['output']>;
  removeProfileCoverImage: Scalars['Boolean']['output'];
  removeUserImage: Scalars['Boolean']['output'];
  reorderAddonCategories?: Maybe<Array<AddonCategoryObject>>;
  reorderTicketCategories?: Maybe<Array<TicketCategoryObject>>;
  rescheduleEvent?: Maybe<EventObject>;
  resendTickets: Scalars['Boolean']['output'];
  scan: Scalars['Boolean']['output'];
  sendOverviewReport?: Maybe<Scalars['Boolean']['output']>;
  submitQuestionnaireAnswers?: Maybe<QuestionnaireSubmission>;
  suspendEvent?: Maybe<EventObject>;
  unredeemAddonPurchase?: Maybe<AddonPurchase>;
  updateArtist?: Maybe<Artist>;
  updateCompany?: Maybe<ProCompany>;
  updateEvent?: Maybe<EventObject>;
  updateOrganizerNote?: Maybe<OrganizerNote>;
  updateProEvent?: Maybe<ProEvent>;
  updatePromoCode?: Maybe<OrganizerPromoCode>;
  updateSeller?: Maybe<ProSeller>;
  updateTicketCategorySaleWindow?: Maybe<TicketCategoryObject>;
  updateUser?: Maybe<UserObject>;
  updateVenue?: Maybe<Venue>;
  upsertAddonCategory?: Maybe<AddonCategoryObject>;
  upsertArtistImage?: Maybe<Scalars['String']['output']>;
  upsertArtistManagement?: Maybe<ArtistManagement>;
  upsertArtistMembers?: Maybe<ArtistMembers>;
  upsertBioSheet?: Maybe<BioSheet>;
  upsertCoSponsor?: Maybe<EventObject>;
  upsertCohost?: Maybe<EventObject>;
  upsertCustomFees?: Maybe<EventObject>;
  upsertEventGroup?: Maybe<EventGroup>;
  upsertPaymentSettings?: Maybe<PaymentSettingsObject>;
  upsertProfile?: Maybe<ProfileObject>;
  upsertQuestionnaire?: Maybe<Questionnaire>;
  upsertSettlement?: Maybe<Settlement>;
  upsertTicketCategory?: Maybe<TicketCategoryObject>;
  upsertVenueImage?: Maybe<Scalars['String']['output']>;
  validateRecaptcha: Scalars['Boolean']['output'];
  voidOrder: Scalars['Boolean']['output'];
};


export type MutationAddEventEmbeddedImageArgs = {
  base64Image?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddGalleryImageArgs = {
  base64Image?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddGuestsArgs = {
  eventId: Scalars['ID']['input'];
  guests: Array<CreateGuestInput>;
};


export type MutationAddInvitesArgs = {
  eventId: Scalars['String']['input'];
  invitees: Array<Scalars['String']['input']>;
};


export type MutationAddNewVenueArgs = {
  input: NewVenueInput;
};


export type MutationAddOrganizerNoteArgs = {
  description: Scalars['String']['input'];
  organizerId: Scalars['String']['input'];
};


export type MutationAddProEventImageArgs = {
  base64Image: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationAddPromoCodeArgs = {
  organizerId: Scalars['String']['input'];
  promoCode: OrganizerPromoCodeInput;
};


export type MutationAddTallBannerImageArgs = {
  base64Image: Scalars['String']['input'];
  carousel: Scalars['Boolean']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationAddToProEventsArgs = {
  eventId: Scalars['ObjectID']['input'];
  input: AddToProEventInput;
};


export type MutationAddToWaitlistArgs = {
  eventId: Scalars['String']['input'];
  waitlistEmail: Scalars['String']['input'];
};


export type MutationAddUserImageArgs = {
  base64Image: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelEventArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<CancelEventInput>;
};


export type MutationChangeGuestArgs = {
  id: Scalars['ID']['input'];
  payload: GuestInput;
};


export type MutationChangeUserRoleArgs = {
  userId: Scalars['String']['input'];
  userRole: Scalars['String']['input'];
};


export type MutationChangeUserTypeArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCheckInGuestArgs = {
  count?: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCheckInOrderArgs = {
  forced?: Scalars['Boolean']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationCheckInTicketArgs = {
  forced?: Scalars['Boolean']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationCheckOutOrderArgs = {
  OrderId: Scalars['ID']['input'];
  forced?: Scalars['Boolean']['input'];
};


export type MutationCheckOutTicketArgs = {
  forced?: Scalars['Boolean']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationContinueSignUpArgs = {
  input: NewUserInput;
};


export type MutationCreateArtistArgs = {
  artist: CreateArtistInput;
};


export type MutationCreateClientCreatedHoldArgs = {
  payload: CreateClientCreatedHoldInput;
};


export type MutationCreateCompOrderArgs = {
  payload: CreateCompOrderInput;
};


export type MutationCreateEventArgs = {
  event?: InputMaybe<CreateEventInput>;
};


export type MutationCreateExternalOrderArgs = {
  payload: CreateExternalOrderInput;
};


export type MutationCreateHoldArgs = {
  maxHoldOverride?: InputMaybe<Scalars['Int']['input']>;
  payload: CreateHoldInput;
  skipConditionsCheck?: Scalars['Boolean']['input'];
};


export type MutationCreateInternalOrderArgs = {
  payload: CreateInternalOrderInput;
};


export type MutationCreateMobileOrderArgs = {
  payload: CreateMobileOrderInput;
};


export type MutationCreateUserArgs = {
  authId: Scalars['String']['input'];
};


export type MutationDeactivateMeArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteAddonCategoryArgs = {
  categoryId: Scalars['String']['input'];
  eventId: Scalars['ObjectID']['input'];
};


export type MutationDeleteArtistArgs = {
  artistId: Scalars['String']['input'];
};


export type MutationDeleteEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationDeleteEventGroupArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteHoldArgs = {
  addToInventory?: Scalars['Boolean']['input'];
  id: Scalars['ObjectID']['input'];
};


export type MutationDeleteOrganizerNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePromoCodeArgs = {
  promoCodeId: Scalars['String']['input'];
};


export type MutationDeleteSeriesScheduleArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationDeleteTicketCategoryArgs = {
  categoryId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationDownloadAdditionalTermsArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationDownloadAdditionalTermsAtConfirmationArgs = {
  shortOrderId: Scalars['String']['input'];
};


export type MutationDownloadTicketsArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationDownloadTicketsAtConfirmationArgs = {
  shortOrderId: Scalars['String']['input'];
};


export type MutationDuplicateAddonCategoryArgs = {
  eventId: Scalars['ObjectID']['input'];
  partial?: InputMaybe<AddonCategoryInput>;
  sourceCategoryId: Scalars['String']['input'];
};


export type MutationDuplicateEventArgs = {
  input?: InputMaybe<CloneEventInput>;
};


export type MutationDuplicateTicketCategoryArgs = {
  eventId: Scalars['String']['input'];
  partial?: InputMaybe<TicketCategoryInput>;
  sourceCategoryId: Scalars['String']['input'];
};


export type MutationEditClientCreatedHoldArgs = {
  payload: EditClientCreatedHoldInput;
};


export type MutationEditOrderEmailArgs = {
  email: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  resendTickets?: Scalars['Boolean']['input'];
};


export type MutationEditOrderNoteArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type MutationEditOrderPurchaserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ObjectID']['input'];
};


export type MutationEnableWaitlistArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationEventImageUploadArgs = {
  base64Image: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationEventScanOutAllArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};


export type MutationImportCompanyEventsArgs = {
  externalId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationImportSellerEventsArgs = {
  proSellerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMessageEventAttendeesArgs = {
  eventId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  toCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMyOrganizedEventsOverviewArgs = {
  input: EventsOverviewInput;
};


export type MutationRedeemAddonPurchaseArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationRefundOrderArgs = {
  fullRefund?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  notifyPurchaser?: Scalars['Boolean']['input'];
  specificAddonPurchaseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  specificProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRemoveCoSponsorArgs = {
  coSponsorId: Scalars['ID']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationRemoveCohostArgs = {
  cohostEmail: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationRemoveEventEmbeddedImageArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveGalleryImageArgs = {
  imageId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveGuestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePaymentSettingsArgs = {
  paymentSettingsId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveProfileCoverImageArgs = {
  imageId: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveUserImageArgs = {
  imageId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReorderAddonCategoriesArgs = {
  eventId: Scalars['ObjectID']['input'];
  order?: InputMaybe<Array<ReorderAddonCategoryInput>>;
};


export type MutationReorderTicketCategoriesArgs = {
  eventId: Scalars['String']['input'];
  order: Array<ReorderTicketCategoryInput>;
};


export type MutationRescheduleEventArgs = {
  eventId: Scalars['String']['input'];
  input?: InputMaybe<RescheduleEventInput>;
};


export type MutationResendTicketsArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationScanArgs = {
  id: Scalars['ObjectID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  type: ScannableType;
};


export type MutationSendOverviewReportArgs = {
  csv?: Scalars['Boolean']['input'];
  eventId: Scalars['String']['input'];
  overviewReport: Scalars['String']['input'];
  toEmail: Scalars['String']['input'];
};


export type MutationSubmitQuestionnaireAnswersArgs = {
  orderShortId: Scalars['String']['input'];
  submissionInput: QuestionnaireSubmissionInput;
};


export type MutationSuspendEventArgs = {
  eventId: Scalars['String']['input'];
  suspended: Scalars['Boolean']['input'];
};


export type MutationUnredeemAddonPurchaseArgs = {
  id: Scalars['ObjectID']['input'];
};


export type MutationUpdateArtistArgs = {
  id: Scalars['String']['input'];
  partial: ArtistInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['String']['input'];
  partial: ProCompanyUpdateInput;
};


export type MutationUpdateEventArgs = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  partial?: InputMaybe<EventInput>;
};


export type MutationUpdateOrganizerNoteArgs = {
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateProEventArgs = {
  id: Scalars['String']['input'];
  partial: ProEventInput;
};


export type MutationUpdatePromoCodeArgs = {
  partial: OrganizerPromoCodeInput;
  promoCodeId: Scalars['String']['input'];
};


export type MutationUpdateSellerArgs = {
  partial: ProSellerInput;
  proSellerId: Scalars['String']['input'];
};


export type MutationUpdateTicketCategorySaleWindowArgs = {
  eventId: Scalars['String']['input'];
  saleEnd?: InputMaybe<Scalars['Time']['input']>;
  saleEndVisible?: InputMaybe<Scalars['Boolean']['input']>;
  saleStart?: InputMaybe<Scalars['Time']['input']>;
  saleStartVisible?: InputMaybe<Scalars['Boolean']['input']>;
  ticketCategoryId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateVenueArgs = {
  id: Scalars['String']['input'];
  partial: VenueInput;
};


export type MutationUpsertAddonCategoryArgs = {
  addonCategory: AddonCategoryInput;
  eventId: Scalars['ObjectID']['input'];
};


export type MutationUpsertArtistImageArgs = {
  base64Image: Scalars['String']['input'];
  fieldName: ArtistImageType;
  id: Scalars['String']['input'];
};


export type MutationUpsertArtistManagementArgs = {
  artistId: Scalars['String']['input'];
  partial: ArtistManagementInput;
};


export type MutationUpsertArtistMembersArgs = {
  artistId: Scalars['String']['input'];
  partial: Array<ArtistMemberInput>;
};


export type MutationUpsertBioSheetArgs = {
  organizerId: Scalars['String']['input'];
  payload: UpsertBioSheetInput;
};


export type MutationUpsertCoSponsorArgs = {
  email: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationUpsertCohostArgs = {
  eventId: Scalars['String']['input'];
  input: UpsertCohostInput;
};


export type MutationUpsertCustomFeesArgs = {
  eventId: Scalars['String']['input'];
  feesGroupsInput?: InputMaybe<Array<FeesGroupInput>>;
  input: Array<UpsertCustomFeeInput>;
};


export type MutationUpsertEventGroupArgs = {
  input: EventGroupInput;
};


export type MutationUpsertPaymentSettingsArgs = {
  ach?: InputMaybe<UpsertAchInput>;
  cheque?: InputMaybe<UpsertChequeInput>;
  eft?: InputMaybe<UpsertEftInput>;
  usdCheck?: InputMaybe<UpsertUsdCheckInput>;
};


export type MutationUpsertProfileArgs = {
  input?: InputMaybe<ProfileInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertQuestionnaireArgs = {
  eventId: Scalars['ObjectID']['input'];
  payload?: InputMaybe<QuestionnaireInput>;
};


export type MutationUpsertSettlementArgs = {
  input: SettlementInput;
};


export type MutationUpsertTicketCategoryArgs = {
  eventId: Scalars['String']['input'];
  ticketCategory: TicketCategoryInput;
};


export type MutationUpsertVenueImageArgs = {
  base64Image: Scalars['String']['input'];
  venueId: Scalars['String']['input'];
};


export type MutationValidateRecaptchaArgs = {
  token: Scalars['String']['input'];
};


export type MutationVoidOrderArgs = {
  id: Scalars['ID']['input'];
  specificAddonPurchaseIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  specificProductIds?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
  voidAll?: Scalars['Boolean']['input'];
};

export type NewUserInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  otherReferralSource?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
};

export type NewVenueInput = {
  accessibilityDetails?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<VenueLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photographerLink?: InputMaybe<Scalars['String']['input']>;
  photographerName?: InputMaybe<Scalars['String']['input']>;
  poweredByAffiliates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  venueType?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type Order = {
  __typename?: 'Order';
  additionalTerms?: Maybe<Scalars['Boolean']['output']>;
  addons: Array<AddonPurchase>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  event?: Maybe<EventObject>;
  id: Scalars['String']['output'];
  liability: Scalars['Int']['output'];
  orderNotes?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<OrderStatus>;
  process?: Maybe<Scalars['String']['output']>;
  processingFee: Scalars['Int']['output'];
  purchaser?: Maybe<OrderPurchaser>;
  questionnaireSubmission?: Maybe<QuestionnaireSubmission>;
  reference: OrderReference;
  serviceFee: Scalars['Int']['output'];
  shortOrderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Array<Scalars['String']['output']>>;
  tickets: Array<Product>;
};

export enum OrderItemType {
  Addon = 'Addon',
  Donation = 'Donation',
  SpecialRequest = 'SpecialRequest',
  Ticket = 'Ticket'
}

export enum OrderProcess {
  Complimentary = 'Complimentary',
  External = 'External',
  Internal = 'Internal',
  Mobile = 'Mobile'
}

export type OrderProfileInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameConfirm?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type OrderPurchaseInput = {
  addons?: InputMaybe<Scalars['QtyMap']['input']>;
  charge: MoneyInput;
  clientEventId: Scalars['ID']['input'];
  tickets: Scalars['Map']['input'];
};

export type OrderPurchaser = {
  __typename?: 'OrderPurchaser';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
};

export type OrderReference = {
  __typename?: 'OrderReference';
  eventId?: Maybe<Scalars['String']['output']>;
  issuedBy?: Maybe<Scalars['String']['output']>;
  specialRequests?: Maybe<Scalars['String']['output']>;
};

export type OrderSortInput = {
  field: Scalars['String']['input'];
  order: SortOrder;
};

export enum OrderStatus {
  Confirmed = 'Confirmed',
  Delivered = 'Delivered',
  Expired = 'Expired',
  Failed = 'Failed',
  Partrefunded = 'Partrefunded',
  Pending = 'Pending',
  Processing = 'Processing',
  Refunded = 'Refunded'
}

export type OrganizerNote = {
  __typename?: 'OrganizerNote';
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  organizerId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type OrganizerPromoCode = {
  __typename?: 'OrganizerPromoCode';
  allEvents?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  codeDescription?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountType: DiscountType;
  endDate?: Maybe<Scalars['Time']['output']>;
  events?: Maybe<Array<PromoCodeEventObj>>;
  id: Scalars['String']['output'];
  maxTicketsPerOrder?: Maybe<Scalars['Int']['output']>;
  minTicketsPerOrder?: Maybe<Scalars['Int']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Time']['output']>;
};

export type OrganizerPromoCodeInput = {
  allEvents?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  codeDescription?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<DiscountType>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  events?: InputMaybe<Array<InputMaybe<PromoCodeEventObjInput>>>;
  maxTicketsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  minTicketsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
};

export type PaginatedArtists = {
  __typename?: 'PaginatedArtists';
  items: Array<Artist>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedEvents = {
  __typename?: 'PaginatedEvents';
  items?: Maybe<Array<EventObject>>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedOrders = {
  __typename?: 'PaginatedOrders';
  items?: Maybe<Array<Order>>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedProCompanies = {
  __typename?: 'PaginatedProCompanies';
  items: Array<ProCompany>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedProEvents = {
  __typename?: 'PaginatedProEvents';
  items: Array<ProEvent>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedProOrders = {
  __typename?: 'PaginatedProOrders';
  items: Array<ProOrder>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedProProducts = {
  __typename?: 'PaginatedProProducts';
  items: Array<ProTicket>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedProSellers = {
  __typename?: 'PaginatedProSellers';
  items: Array<ProSeller>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedProducts = {
  __typename?: 'PaginatedProducts';
  csv: Scalars['String']['output'];
  items?: Maybe<Array<Product>>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedScanLog = {
  __typename?: 'PaginatedScanLog';
  csv: Scalars['String']['output'];
  items?: Maybe<Array<ScanActivityObject>>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedUsersResponse = {
  __typename?: 'PaginatedUsersResponse';
  items?: Maybe<Array<Maybe<UserObject>>>;
  skip?: Maybe<Scalars['Float']['output']>;
  take?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PaginatedVenues = {
  __typename?: 'PaginatedVenues';
  items: Array<Venue>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum PaymentCurrency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type PaymentRequestInput = {
  applePayToken?: InputMaybe<Scalars['String']['input']>;
  cardHolderName?: InputMaybe<Scalars['String']['input']>;
  clientRequestId?: InputMaybe<Scalars['String']['input']>;
  googlePayToken?: InputMaybe<Scalars['String']['input']>;
  nonce?: InputMaybe<Scalars['String']['input']>;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentSettingsObject = {
  __typename?: 'PaymentSettingsObject';
  accountNo?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
  bankAccountType?: Maybe<BankAccountType>;
  canRemove?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  corporation?: Maybe<Scalars['Boolean']['output']>;
  corporationName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  institutionNo?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentType?: Maybe<PaymentType>;
  phone?: Maybe<Scalars['String']['output']>;
  routingNo?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  transitNo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum PaymentType {
  Ach = 'ach',
  Cheque = 'cheque',
  Eft = 'eft',
  UsdCheck = 'usd_check'
}

export type PeakScanTimeObject = {
  __typename?: 'PeakScanTimeObject';
  endTime: Scalars['Time']['output'];
  scanCount: Scalars['Int']['output'];
  startTime: Scalars['Time']['output'];
};

export type PostCheckoutCta = {
  __typename?: 'PostCheckoutCta';
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PostCheckoutCtaInput = {
  link: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type PostCodeSales = {
  __typename?: 'PostCodeSales';
  postalCode: Scalars['String']['output'];
  sales: Scalars['Int']['output'];
};

export enum PricingInput {
  FreeOnly = 'FreeOnly',
  PaidOnly = 'PaidOnly'
}

export type ProCompany = {
  __typename?: 'ProCompany';
  alias?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  externalId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  syncEvents?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalCompanyEvents?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ProCompanyUpdateInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  syncEvents?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ProEvent = {
  __typename?: 'ProEvent';
  accessibilityDetails?: Maybe<Scalars['String']['output']>;
  admitoneTitle?: Maybe<Scalars['String']['output']>;
  ageLimit?: Maybe<Scalars['Boolean']['output']>;
  ageLimitValue?: Maybe<Scalars['Int']['output']>;
  artistIds?: Maybe<Array<Scalars['ID']['output']>>;
  artists?: Maybe<Array<Artist>>;
  bannerTall?: Maybe<Scalars['String']['output']>;
  carousel?: Maybe<Scalars['Boolean']['output']>;
  carouselLinkTo?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clientEventUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventDoorTime?: Maybe<Scalars['Time']['output']>;
  eventEnd?: Maybe<Scalars['Time']['output']>;
  eventStart?: Maybe<Scalars['Time']['output']>;
  eventTimeEnd?: Maybe<Scalars['String']['output']>;
  eventTimeStart?: Maybe<Scalars['String']['output']>;
  fbPixelId?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  frontEndGenres?: Maybe<Array<Scalars['String']['output']>>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  hiddenUntil?: Maybe<Scalars['Time']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  internalGenres?: Maybe<Array<Scalars['String']['output']>>;
  layaway?: Maybe<Scalars['Boolean']['output']>;
  pinterestPixelId?: Maybe<Scalars['String']['output']>;
  promoters?: Maybe<Array<ProEventPromoters>>;
  promotions?: Maybe<ProEventPromotions>;
  provider?: Maybe<Scalars['String']['output']>;
  redirect?: Maybe<Scalars['Boolean']['output']>;
  resaleEventId?: Maybe<Scalars['String']['output']>;
  salesOpen?: Maybe<Scalars['Time']['output']>;
  searchableTags?: Maybe<Array<Scalars['String']['output']>>;
  secondaryArtistIds?: Maybe<Array<Scalars['ID']['output']>>;
  secondaryArtists?: Maybe<Array<Artist>>;
  sellerId?: Maybe<Scalars['Int']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  showclixId?: Maybe<Scalars['Int']['output']>;
  snapchatPixelId?: Maybe<Scalars['String']['output']>;
  soldOut?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  ticketRange?: Maybe<Scalars['String']['output']>;
  ticketRangeIncludesFees?: Maybe<Scalars['Boolean']['output']>;
  tiktokPixelId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tourName?: Maybe<Scalars['String']['output']>;
  twitterPixelId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  venue?: Maybe<ProEventVenue>;
  waitlistUrl?: Maybe<Scalars['String']['output']>;
};

export type ProEventInput = {
  accessibilityDetails?: InputMaybe<Scalars['String']['input']>;
  admitoneTitle?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Boolean']['input']>;
  ageLimitValue?: InputMaybe<Scalars['Int']['input']>;
  artistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  carousel?: InputMaybe<Scalars['Boolean']['input']>;
  carouselLinkTo?: InputMaybe<Scalars['String']['input']>;
  eventDoorTime?: InputMaybe<Scalars['Time']['input']>;
  fbPixelId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  frontEndGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenUntil?: InputMaybe<Scalars['Time']['input']>;
  internalGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  pinterestPixelId?: InputMaybe<Scalars['String']['input']>;
  promoters?: InputMaybe<Array<ProEventPromotersInput>>;
  promotions?: InputMaybe<ProEventPromotionsInput>;
  resaleEventId?: InputMaybe<Scalars['String']['input']>;
  searchableTags?: InputMaybe<Array<Scalars['String']['input']>>;
  secondaryArtistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  snapchatPixelId?: InputMaybe<Scalars['String']['input']>;
  soldOut?: InputMaybe<Scalars['Boolean']['input']>;
  ticketRange?: InputMaybe<Scalars['String']['input']>;
  ticketRangeIncludesFees?: InputMaybe<Scalars['Boolean']['input']>;
  tiktokPixelId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  tourName?: InputMaybe<Scalars['String']['input']>;
  twitterPixelId?: InputMaybe<Scalars['String']['input']>;
  waitlistUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ProEventLocation = {
  __typename?: 'ProEventLocation';
  address?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ProEventPromoters = {
  __typename?: 'ProEventPromoters';
  promoterLink?: Maybe<Scalars['String']['output']>;
  promoterName?: Maybe<Scalars['String']['output']>;
};

export type ProEventPromotersInput = {
  promoterLink?: InputMaybe<Scalars['String']['input']>;
  promoterName?: InputMaybe<Scalars['String']['input']>;
};

export type ProEventPromotions = {
  __typename?: 'ProEventPromotions';
  discount?: Maybe<Scalars['String']['output']>;
  discountStart?: Maybe<Scalars['String']['output']>;
  discountUntil?: Maybe<Scalars['String']['output']>;
  onSale?: Maybe<Scalars['Boolean']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
};

export type ProEventPromotionsInput = {
  discount?: InputMaybe<Scalars['String']['input']>;
  discountStart?: InputMaybe<Scalars['String']['input']>;
  discountUntil?: InputMaybe<Scalars['String']['input']>;
  onSale: Scalars['Boolean']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProEventVenue = {
  __typename?: 'ProEventVenue';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<EventAddressLocation>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type ProOrder = {
  __typename?: 'ProOrder';
  captureMethod?: Maybe<Scalars['String']['output']>;
  confirmationId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dateCompleted?: Maybe<Scalars['Time']['output']>;
  deliveryType?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  showClixId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Time']['output']>;
  tickets?: Maybe<Array<ProTicket>>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type ProSeller = {
  __typename?: 'ProSeller';
  createdAt?: Maybe<Scalars['Time']['output']>;
  hideDefault?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  showclixID?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalProSellerEvents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type ProSellerInput = {
  hideDefault?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProTicket = {
  __typename?: 'ProTicket';
  barcode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  event?: Maybe<ProEvent>;
  eventId?: Maybe<Scalars['String']['output']>;
  faceValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  nameOnOrder?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  showClixId?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  categoryId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  holder?: Maybe<Attendee>;
  id: Scalars['String']['output'];
  isDonation?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  refundDetails?: Maybe<RefundDetails>;
  scanInTime?: Maybe<Scalars['Time']['output']>;
  scanOutTime?: Maybe<Scalars['Time']['output']>;
  transactions?: Maybe<ProductTransactions>;
  type?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<ProductUnitCost>;
};

export type ProductTransaction = {
  __typename?: 'ProductTransaction';
  id?: Maybe<Scalars['String']['output']>;
};

export type ProductTransactions = {
  __typename?: 'ProductTransactions';
  capture: ProductTransaction;
  refund: ProductTransaction;
  void: ProductTransaction;
};

export type ProductUnitCost = {
  __typename?: 'ProductUnitCost';
  basePrice: Money;
  processingFee: Money;
  serviceFee: Money;
};

export type ProductsSummary = {
  __typename?: 'ProductsSummary';
  totalFreeTickets: Scalars['Int']['output'];
  totalGrossAmount: Scalars['Int']['output'];
  totalPaidTickets: Scalars['Int']['output'];
  totalVoidTickets: Scalars['Int']['output'];
};

export type ProfileFavouriteItemInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileFavouriteItemObject = {
  __typename?: 'ProfileFavouriteItemObject';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProfileInput = {
  CoverPhoto?: InputMaybe<Scalars['String']['input']>;
  CoverPhotoAlt?: InputMaybe<Scalars['String']['input']>;
  DefaultListingOption?: InputMaybe<Scalars['String']['input']>;
  EventListingOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  VenueLocation?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  favouriteArtists?: InputMaybe<Array<InputMaybe<ProfileFavouriteItemInput>>>;
  favouriteGenres?: InputMaybe<Array<InputMaybe<ProfileFavouriteItemInput>>>;
  favouriteVenues?: InputMaybe<Array<InputMaybe<ProfileFavouriteItemInput>>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  screenName?: InputMaybe<Scalars['String']['input']>;
  themeColour?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  twitterX?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileObject = {
  __typename?: 'ProfileObject';
  CoverPhoto?: Maybe<Scalars['String']['output']>;
  CoverPhotoAlt?: Maybe<Scalars['String']['output']>;
  DefaultListingOption?: Maybe<Scalars['String']['output']>;
  EventListingOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Gallery?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  VenueLocation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  favouriteArtists?: Maybe<Array<Maybe<ProfileFavouriteItemObject>>>;
  favouriteGenres?: Maybe<Array<Maybe<ProfileFavouriteItemObject>>>;
  favouriteVenues?: Maybe<Array<Maybe<ProfileFavouriteItemObject>>>;
  id?: Maybe<Scalars['ID']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  screenName?: Maybe<Scalars['String']['output']>;
  themeColour?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitterX?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  userType?: Maybe<UserType>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  code: Scalars['String']['output'];
  codeDescription?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountType: DiscountType;
  endDate?: Maybe<Scalars['Time']['output']>;
  hashedPromoCode?: Maybe<Scalars['String']['output']>;
  maxTicketsPerOrder?: Maybe<Scalars['Int']['output']>;
  minTicketsPerOrder?: Maybe<Scalars['Int']['output']>;
  shortId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Time']['output']>;
  ticketTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type PromoCodeEventObj = {
  __typename?: 'PromoCodeEventObj';
  eventId: Scalars['String']['output'];
  eventTitle?: Maybe<Scalars['String']['output']>;
  ticketTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type PromoCodeEventObjInput = {
  eventId: Scalars['String']['input'];
  ticketTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PromoCodeInput = {
  code: Scalars['String']['input'];
  codeDescription?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountType: DiscountType;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  maxTicketsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  minTicketsPerOrder?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  ticketTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PromoCodeSalesDataObject = {
  __typename?: 'PromoCodeSalesDataObject';
  code: Scalars['String']['output'];
  redeemed: Scalars['Int']['output'];
  totalLiability: Scalars['Int']['output'];
};

export type PublicProfileObject = {
  __typename?: 'PublicProfileObject';
  CoverPhoto?: Maybe<Scalars['String']['output']>;
  CoverPhotoAlt?: Maybe<Scalars['String']['output']>;
  DefaultListingOption?: Maybe<Scalars['String']['output']>;
  EventListingOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Gallery?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  VenueLocation?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  profileImg?: Maybe<Scalars['String']['output']>;
  screenName?: Maybe<Scalars['String']['output']>;
  themeColour?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitterX?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<UserType>;
  website?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  addonPurchase?: Maybe<AddonPurchase>;
  adminAllEvents?: Maybe<PaginatedEvents>;
  adminEventsCalendar?: Maybe<Array<EventObject>>;
  allArtists?: Maybe<Array<Artist>>;
  allProSellers?: Maybe<Array<ProSeller>>;
  artist?: Maybe<Artist>;
  artists?: Maybe<PaginatedArtists>;
  bioSheet?: Maybe<BioSheet>;
  calculateFees: CalculateFeesResult;
  calculateFlexibleTicketPrice?: Maybe<Array<TicketCategoryUnitPrice>>;
  event?: Maybe<EventObject>;
  eventGroup?: Maybe<EventGroup>;
  eventGroups?: Maybe<Array<EventGroup>>;
  eventTags?: Maybe<Array<Scalars['String']['output']>>;
  events?: Maybe<PaginatedEvents>;
  getEventGoogleAnalytics: Array<AnalyticsObject>;
  getEventGoogleAnalyticsTotals: AnalyticsTotalsObject;
  getEventsByTopCategories?: Maybe<Array<EventObject>>;
  getOrganizer?: Maybe<UserObject>;
  getOrganizerPublicProfile?: Maybe<PublicProfileObject>;
  getPoweredByOrganizers?: Maybe<Array<UserObject>>;
  getProCompanies?: Maybe<PaginatedProCompanies>;
  globalFees: GlobalFees;
  me?: Maybe<UserObject>;
  myAttendedEvents?: Maybe<PaginatedEvents>;
  myOrganizedEvents?: Maybe<PaginatedEvents>;
  myOrganizedEventsCalendar?: Maybe<Array<EventObject>>;
  order: Order;
  orders: PaginatedOrders;
  ordersCsv?: Maybe<Scalars['String']['output']>;
  organizerEvents?: Maybe<PaginatedEvents>;
  organizerNotes?: Maybe<Array<OrganizerNote>>;
  ping: Scalars['String']['output'];
  proAdminUsers?: Maybe<Array<UserObject>>;
  proCompany?: Maybe<ProCompany>;
  proEvent?: Maybe<ProEvent>;
  proEvents?: Maybe<PaginatedProEvents>;
  proOrder?: Maybe<ProOrder>;
  proOrders?: Maybe<PaginatedProOrders>;
  proProduct?: Maybe<ProTicket>;
  proProducts?: Maybe<PaginatedProProducts>;
  proSeller?: Maybe<ProSeller>;
  proSellers?: Maybe<PaginatedProSellers>;
  productsSummary?: Maybe<ProductsSummary>;
  promoCode?: Maybe<OrganizerPromoCode>;
  promoCodeEvents?: Maybe<PaginatedEvents>;
  promoCodes?: Maybe<Array<OrganizerPromoCode>>;
  publicArtist?: Maybe<Artist>;
  publicProEvent?: Maybe<ProEvent>;
  publicProEvents?: Maybe<PaginatedProEvents>;
  salesByLocation?: Maybe<SalesByLocation>;
  scannables?: Maybe<Array<ScannableObject>>;
  settlement?: Maybe<Settlement>;
  settlements?: Maybe<Array<Settlement>>;
  trackOrders?: Maybe<Array<Tracker>>;
  users?: Maybe<PaginatedUsersResponse>;
  venue?: Maybe<Venue>;
  venues?: Maybe<PaginatedVenues>;
};


export type QueryAddonPurchaseArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryAdminAllEventsArgs = {
  from?: InputMaybe<Scalars['Time']['input']>;
  orderBy?: InputMaybe<BsonSortInput>;
  organizerId?: InputMaybe<Array<Scalars['String']['input']>>;
  restriction?: InputMaybe<EventRestriction>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  status?: InputMaybe<Array<EventStatus>>;
  take?: Scalars['Int']['input'];
  to?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryAdminEventsCalendarArgs = {
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDateRange?: InputMaybe<DateRangeInput>;
};


export type QueryArtistArgs = {
  id: Scalars['String']['input'];
};


export type QueryArtistsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryBioSheetArgs = {
  organizerId: Scalars['String']['input'];
};


export type QueryCalculateFeesArgs = {
  currency?: PaymentCurrency;
  deductFees?: Scalars['Boolean']['input'];
  enteredAmount: Scalars['Int']['input'];
};


export type QueryCalculateFlexibleTicketPriceArgs = {
  amount: Scalars['Int']['input'];
  categoryId: Scalars['String']['input'];
  eventId: Scalars['ObjectID']['input'];
};


export type QueryEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventGroupArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryEventsArgs = {
  categories?: InputMaybe<Array<EventCategory>>;
  city?: InputMaybe<EventCity>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  eventGroupTag?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<GeolocationPoints>;
  locations?: InputMaybe<Array<EventLocation>>;
  onlyPoweredby?: Scalars['Boolean']['input'];
  orderBy?: InputMaybe<BsonSortInput>;
  pricing?: InputMaybe<PricingInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  startDateRange?: InputMaybe<DateRangeInput>;
  surface?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  take?: Scalars['Int']['input'];
};


export type QueryGetEventGoogleAnalyticsArgs = {
  eventId: Scalars['ObjectID']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGetEventGoogleAnalyticsTotalsArgs = {
  eventId: Scalars['ObjectID']['input'];
};


export type QueryGetEventsByTopCategoriesArgs = {
  city?: InputMaybe<EventCity>;
};


export type QueryGetOrganizerArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOrganizerPublicProfileArgs = {
  organizerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProCompaniesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['String']['input'];
  skip?: Scalars['Int']['input'];
  syncEvents?: InputMaybe<Scalars['Boolean']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryMyAttendedEventsArgs = {
  orderBy?: InputMaybe<BsonSortInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  startDateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<Array<EventStatus>>;
  take?: Scalars['Int']['input'];
};


export type QueryMyOrganizedEventsArgs = {
  current?: Scalars['Boolean']['input'];
  endDate?: InputMaybe<Scalars['Time']['input']>;
  endDateRange?: InputMaybe<DateRangeInput>;
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<EventLocation>>;
  orderBy?: InputMaybe<BsonSortInput>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  restriction?: InputMaybe<EventRestriction>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateRange?: InputMaybe<DateRangeInput>;
  status?: InputMaybe<Array<EventStatus>>;
  take?: Scalars['Int']['input'];
  twoWeeksFromNow?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMyOrganizedEventsCalendarArgs = {
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDateRange?: InputMaybe<DateRangeInput>;
};


export type QueryOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrdersArgs = {
  containsItemType?: InputMaybe<Array<OrderItemType>>;
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  entryTime?: InputMaybe<EntryTimeFilter>;
  eventId?: InputMaybe<Array<Scalars['String']['input']>>;
  includesSpecialRequests?: InputMaybe<Scalars['Boolean']['input']>;
  organizerId?: InputMaybe<Array<Scalars['String']['input']>>;
  process?: InputMaybe<Array<OrderProcess>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  sort?: InputMaybe<OrderSortInput>;
  status?: InputMaybe<Array<TransactionType>>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryOrdersCsvArgs = {
  containsItemType?: InputMaybe<Array<OrderItemType>>;
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  entryTime?: InputMaybe<EntryTimeFilter>;
  eventId?: InputMaybe<Array<Scalars['String']['input']>>;
  includesSpecialRequests?: InputMaybe<Scalars['Boolean']['input']>;
  ordersWithAddonsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizerId?: InputMaybe<Array<Scalars['String']['input']>>;
  process?: InputMaybe<Array<OrderProcess>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<OrderSortInput>;
  status?: InputMaybe<Array<TransactionType>>;
};


export type QueryOrganizerEventsArgs = {
  current?: Scalars['Boolean']['input'];
  orderBy?: InputMaybe<BsonSortInput>;
  organizerId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  startDateRange?: InputMaybe<DateRangeInput>;
  take?: Scalars['Int']['input'];
};


export type QueryOrganizerNotesArgs = {
  organizerId: Scalars['String']['input'];
};


export type QueryProCompanyArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryProEventArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProEventsArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  current?: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
  venueId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProOrderArgs = {
  id: Scalars['String']['input'];
};


export type QueryProOrdersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryProProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProProductsArgs = {
  from?: InputMaybe<Scalars['Time']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryProSellerArgs = {
  id: Scalars['String']['input'];
};


export type QueryProSellersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryProductsSummaryArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPromoCodeArgs = {
  promoCodeId: Scalars['String']['input'];
};


export type QueryPromoCodeEventsArgs = {
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizerId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromoCodesArgs = {
  organizerId: Scalars['String']['input'];
};


export type QueryPublicArtistArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicProEventArgs = {
  shortName: Scalars['String']['input'];
};


export type QueryPublicProEventsArgs = {
  artistId?: InputMaybe<Scalars['ObjectID']['input']>;
  carousel?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  distance: Scalars['Int']['input'];
  excludedGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  includedGenres?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<GeolocationPoints>;
  search?: InputMaybe<Scalars['String']['input']>;
  sellerId?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  startDateRange?: InputMaybe<DateRangeInput>;
  take?: Scalars['Int']['input'];
  venueId?: InputMaybe<Array<Scalars['ObjectID']['input']>>;
};


export type QuerySalesByLocationArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryScannablesArgs = {
  eventId: Scalars['ObjectID']['input'];
};


export type QuerySettlementArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryUsersArgs = {
  minEventsOrganized?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryVenueArgs = {
  id: Scalars['String']['input'];
};


export type QueryVenuesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export type Question = {
  __typename?: 'Question';
  followup?: Maybe<FollowupQuestion>;
  isRequired: Scalars['Boolean']['output'];
  options?: Maybe<Array<QuestionOption>>;
  sequenceOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  ticketCategoryIds: Array<Scalars['String']['output']>;
  type: QuestionType;
};

export type QuestionInput = {
  followup?: InputMaybe<FollowupQuestionInput>;
  isRequired: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<QuestionOptionInput>>;
  text: Scalars['String']['input'];
  ticketCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type: QuestionType;
};

export type QuestionOption = {
  __typename?: 'QuestionOption';
  followup?: Maybe<FollowupQuestion>;
  text: Scalars['String']['output'];
};

export type QuestionOptionInput = {
  followup?: InputMaybe<FollowupQuestionInput>;
  text: Scalars['String']['input'];
};

export enum QuestionType {
  MultipleChoice = 'multipleChoice',
  SingleChoice = 'singleChoice',
  Text = 'text'
}

export type Questionnaire = {
  __typename?: 'Questionnaire';
  createdAt?: Maybe<Scalars['Time']['output']>;
  eventId: Scalars['ObjectID']['output'];
  id: Scalars['ObjectID']['output'];
  questions: Array<Question>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  version: Scalars['Int']['output'];
};

export type QuestionnaireAnswer = {
  __typename?: 'QuestionnaireAnswer';
  answer?: Maybe<Array<Scalars['String']['output']>>;
  question: Scalars['String']['output'];
};

export type QuestionnaireAnswerInput = {
  answer: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type QuestionnaireInput = {
  questions?: InputMaybe<Array<QuestionInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireSubmission = {
  __typename?: 'QuestionnaireSubmission';
  answers: Array<QuestionnaireAnswer>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  questionnaireVersion: Scalars['Int']['output'];
};

export type QuestionnaireSubmissionInput = {
  answers: Array<QuestionnaireAnswerInput>;
  questionnaireVersion: Scalars['Int']['input'];
};

export type ReferralCode = {
  __typename?: 'ReferralCode';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  liability?: Maybe<Scalars['Int']['output']>;
  orderCount?: Maybe<Scalars['Int']['output']>;
  processingFee?: Maybe<Scalars['Int']['output']>;
  serviceFee?: Maybe<Scalars['Int']['output']>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
};

export type ReferralCodeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type RefundDetails = {
  __typename?: 'RefundDetails';
  amount: Scalars['Int']['output'];
  type: RefundType;
};

export enum RefundType {
  FullRefund = 'FULL_REFUND',
  PartialRefund = 'PARTIAL_REFUND'
}

export type ReorderAddonCategoryInput = {
  categoryId: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type ReorderTicketCategoryInput = {
  categoryId: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type ReportData = {
  __typename?: 'ReportData';
  addonRevenue: Scalars['Int']['output'];
  donationRevenue: Scalars['Int']['output'];
  fees?: Maybe<Array<FeeItem>>;
  freeTickets: Scalars['Int']['output'];
  grandTotal: Scalars['Int']['output'];
  paidTickets: Scalars['Int']['output'];
  ticketRevenue: Scalars['Int']['output'];
};

export type RescheduleEventInput = {
  endDate: Scalars['Time']['input'];
  forced?: Scalars['Boolean']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Time']['input'];
};

export type SalesByLocation = {
  __typename?: 'SalesByLocation';
  citySales?: Maybe<Array<CitySales>>;
  postalCodeSales?: Maybe<Array<PostCodeSales>>;
};

export type ScanActivityObject = {
  __typename?: 'ScanActivityObject';
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  process?: Maybe<Scalars['String']['output']>;
  scanInTime?: Maybe<Scalars['Time']['output']>;
  scanOutTime?: Maybe<Scalars['Time']['output']>;
  ticketId: Scalars['String']['output'];
};

export type ScanCountObject = {
  __typename?: 'ScanCountObject';
  in: Scalars['Int']['output'];
  out: Scalars['Int']['output'];
};

export type ScanCountWithActiveObject = {
  __typename?: 'ScanCountWithActiveObject';
  active: Scalars['Int']['output'];
  in: Scalars['Int']['output'];
  out: Scalars['Int']['output'];
};

export type ScannableObject = {
  __typename?: 'ScannableObject';
  categoryId: Scalars['String']['output'];
  donation: Scalars['Boolean']['output'];
  eventId: Scalars['ObjectID']['output'];
  id: Scalars['ObjectID']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['ObjectID']['output'];
  type: ScannableType;
  valid: Scalars['Boolean']['output'];
  void: Scalars['Boolean']['output'];
};

export enum ScannableType {
  Addon = 'Addon',
  Ticket = 'Ticket'
}

export type SeriesScheduleInput = {
  lastEventChoice?: InputMaybe<Scalars['String']['input']>;
  monthlyOptions?: InputMaybe<MonthlyOptionsInput>;
  seriesEndDate?: InputMaybe<Scalars['Time']['input']>;
  seriesFrequency?: InputMaybe<Scalars['Int']['input']>;
  seriesType: Scalars['String']['input'];
  singleOccurrenceEndTime: Scalars['Time']['input'];
  startDateTime: Scalars['Time']['input'];
  timezone: Scalars['String']['input'];
  weeklyOptions?: InputMaybe<Array<Weekday>>;
};

export type SeriesScheduleObject = {
  __typename?: 'SeriesScheduleObject';
  lastEventChoice?: Maybe<Scalars['String']['output']>;
  monthlyOptions?: Maybe<MonthlyOptionsObject>;
  seriesEndDate?: Maybe<Scalars['Time']['output']>;
  seriesFrequency?: Maybe<Scalars['Int']['output']>;
  seriesType?: Maybe<Scalars['String']['output']>;
  singleOccurrenceEndTime?: Maybe<Scalars['Time']['output']>;
  startDateTime?: Maybe<Scalars['Time']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  weeklyOptions?: Maybe<Array<Maybe<Weekday>>>;
};

export type Settlement = {
  __typename?: 'Settlement';
  createdAt: Scalars['Time']['output'];
  deductions: Array<SettlementDeduction>;
  eventIds: Array<Scalars['ObjectID']['output']>;
  events: Array<EventObject>;
  id: Scalars['ObjectID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type SettlementDeduction = {
  __typename?: 'SettlementDeduction';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SettlementDeductionInput = {
  amount: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type SettlementInput = {
  deductions: Array<SettlementDeductionInput>;
  eventIds: Array<Scalars['ObjectID']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TicketCategoryConditionsObject = {
  __typename?: 'TicketCategoryConditionsObject';
  saleWindow?: Maybe<TicketCategorySaleWindowObject>;
};

export type TicketCategoryEntryTime = {
  __typename?: 'TicketCategoryEntryTime';
  from?: Maybe<Scalars['Time']['output']>;
  to?: Maybe<Scalars['Time']['output']>;
};

export type TicketCategoryEntryTimeInput = {
  from?: InputMaybe<Scalars['Time']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
};

export type TicketCategoryInput = {
  appsVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  codeToUnlock?: InputMaybe<Array<Scalars['String']['input']>>;
  customFees?: InputMaybe<Array<UpsertCustomFeeInput>>;
  deductFees?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displaySoldOut?: InputMaybe<Scalars['Boolean']['input']>;
  enteredAmount?: InputMaybe<Scalars['Int']['input']>;
  entryTimes?: InputMaybe<Array<InputMaybe<TicketCategoryEntryTimeInput>>>;
  flexiblePricing?: InputMaybe<FlexiblePricingInput>;
  isQuantityMinStrict?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantityLimit?: InputMaybe<Scalars['Int']['input']>;
  quantityMax?: InputMaybe<Scalars['Int']['input']>;
  quantityMin?: InputMaybe<Scalars['Int']['input']>;
  sourceTicketCatId?: InputMaybe<Scalars['String']['input']>;
  ticketTag?: InputMaybe<TicketTag>;
  unlockCondition?: InputMaybe<TicketCategoryUnlockConditionInput>;
  visibility?: InputMaybe<TicketCategoryVisibility>;
};

export type TicketCategoryObject = {
  __typename?: 'TicketCategoryObject';
  appsVisibility?: Maybe<Scalars['Boolean']['output']>;
  basePrice?: Maybe<Money>;
  categoryId: Scalars['String']['output'];
  codeToUnlock?: Maybe<Array<Scalars['String']['output']>>;
  conditions?: Maybe<TicketCategoryConditionsObject>;
  customFees?: Maybe<Array<CustomFeeObject>>;
  deductFees?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displaySoldOut?: Maybe<Scalars['Boolean']['output']>;
  enteredAmount?: Maybe<Money>;
  entryTimes?: Maybe<Array<Maybe<TicketCategoryEntryTime>>>;
  eventId?: Maybe<Scalars['String']['output']>;
  flexiblePricing?: Maybe<FlexiblePricingObject>;
  hashedUnlockCode?: Maybe<Array<Scalars['String']['output']>>;
  holds?: Maybe<Array<HoldObject>>;
  inventory?: Maybe<Scalars['Int']['output']>;
  isQuantityMinStrict?: Maybe<Scalars['Boolean']['output']>;
  liabilityTotal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  pairedAddons?: Maybe<Array<AddonCategoryObject>>;
  processingFee?: Maybe<Money>;
  quantityDistributed?: Maybe<Scalars['Int']['output']>;
  quantityIssued?: Maybe<Scalars['Int']['output']>;
  quantityLimit?: Maybe<Scalars['Int']['output']>;
  quantityMax?: Maybe<Scalars['Int']['output']>;
  quantityMin?: Maybe<Scalars['Int']['output']>;
  salesData?: Maybe<TicketCategorySalesData>;
  scanCounts?: Maybe<ScanCountObject>;
  serviceFee?: Maybe<Money>;
  sourceTicketCatId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticketTag?: Maybe<TicketTag>;
  unitPrice?: Maybe<Array<Maybe<TicketCategoryUnitPrice>>>;
  unlockCondition?: Maybe<TicketCategoryUnlockCondition>;
  visibility?: Maybe<TicketCategoryVisibility>;
};


export type TicketCategoryObjectQuantityDistributedArgs = {
  timeRange?: InputMaybe<DateRangeInput>;
};


export type TicketCategoryObjectSalesDataArgs = {
  dateFrom?: InputMaybe<Scalars['Time']['input']>;
  dateTo?: InputMaybe<Scalars['Time']['input']>;
  process?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TicketCategorySaleWindowObject = {
  __typename?: 'TicketCategorySaleWindowObject';
  from?: Maybe<Scalars['Time']['output']>;
  fromDateVisible?: Maybe<Scalars['Boolean']['output']>;
  to?: Maybe<Scalars['Time']['output']>;
  toDateVisible?: Maybe<Scalars['Boolean']['output']>;
};

export type TicketCategorySalesData = {
  __typename?: 'TicketCategorySalesData';
  categoryLiability: Scalars['Int']['output'];
  complimentaryCount: Scalars['Int']['output'];
  promoCodesUsed?: Maybe<Array<PromoCodeSalesDataObject>>;
  refundedCount: Scalars['Int']['output'];
  scanActivity: Array<ScanActivityObject>;
  soldCount: Scalars['Int']['output'];
  soldWithCodeCount: Scalars['Int']['output'];
  voidedCount: Scalars['Int']['output'];
};

export type TicketCategoryUnitPrice = {
  __typename?: 'TicketCategoryUnitPrice';
  charge?: Maybe<Money>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  uniqueKey?: Maybe<Scalars['String']['output']>;
};

export type TicketCategoryUnlockCondition = {
  __typename?: 'TicketCategoryUnlockCondition';
  amount: Scalars['Int']['output'];
  calculation: UnlockCalculationType;
  dependsOn: Scalars['String']['output'];
};

export type TicketCategoryUnlockConditionInput = {
  amount: Scalars['Int']['input'];
  calculation: UnlockCalculationType;
  dependsOn: Scalars['String']['input'];
};

export enum TicketCategoryVisibility {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

export type TicketCheckInOutput = {
  __typename?: 'TicketCheckInOutput';
  status: TicketCheckInStatus;
  ticket: Product;
};

export enum TicketCheckInStatus {
  Fail = 'Fail',
  OffEntryWindow = 'OffEntryWindow',
  Success = 'Success'
}

export enum TicketTag {
  AddOn = 'addOn',
  BestSeller = 'bestSeller',
  EarlyBird = 'earlyBird',
  Exclusive = 'exclusive',
  HotDeal = 'hotDeal',
  LimitedQuantity = 'limitedQuantity',
  LimitedTime = 'limitedTime',
  SellingFast = 'sellingFast',
  Upgrade = 'upgrade'
}

export type Tracker = {
  __typename?: 'Tracker';
  createdAt?: Maybe<Scalars['Time']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  process?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  charged?: Maybe<Money>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  processor?: Maybe<Scalars['String']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  relatedTransactions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
};

export enum TransactionType {
  Capture = 'CAPTURE',
  Refund = 'REFUND',
  Void = 'VOID'
}

export enum UnlockCalculationType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type UpdateUserInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UploadEventImageObject = {
  __typename?: 'UploadEventImageObject';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UpsertAchInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankAccountType?: InputMaybe<BankAccountType>;
  city?: InputMaybe<Scalars['String']['input']>;
  corporation?: InputMaybe<Scalars['Boolean']['input']>;
  corporationName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  routingNo?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBioSheetInput = {
  altPlatforms?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Array<Scalars['String']['input']>>;
  organizerClass?: InputMaybe<Scalars['String']['input']>;
  organizerId: Scalars['String']['input'];
  organizerName?: InputMaybe<Scalars['String']['input']>;
  organizerType?: InputMaybe<Scalars['String']['input']>;
  otherReferralSource?: InputMaybe<Scalars['String']['input']>;
  otherVenueName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  salesDetails?: InputMaybe<Scalars['String']['input']>;
  venueName?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertChequeInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  corporation?: InputMaybe<Scalars['Boolean']['input']>;
  corporationName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertCohostInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<CohostPermission>>>;
};

export type UpsertCustomFeeInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  percentRate?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertEftInput = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  corporation?: InputMaybe<Scalars['Boolean']['input']>;
  corporationName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  institutionNo?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  transitNo?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertUsdCheckInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  corporation?: InputMaybe<Scalars['Boolean']['input']>;
  corporationName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserObject = {
  __typename?: 'UserObject';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  authId?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  dob?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enableAdditionalTerms?: Maybe<Scalars['Boolean']['output']>;
  enableAddons?: Maybe<Scalars['Boolean']['output']>;
  enableDonations?: Maybe<Scalars['Boolean']['output']>;
  enableNewOrders?: Maybe<Scalars['Boolean']['output']>;
  enablePromoCodes?: Maybe<Scalars['Boolean']['output']>;
  enableReporting?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  paymentCurrencies?: Maybe<Array<Scalars['String']['output']>>;
  paymentSettings?: Maybe<Array<PaymentSettingsObject>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<ProfileObject>;
  role?: Maybe<UserRole>;
  screenName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  userType?: Maybe<UserType>;
};

export enum UserRole {
  Admin = 'admin',
  Editor = 'editor',
  Manager = 'manager',
  Member = 'member',
  SuperAdmin = 'superAdmin',
  ViewOnly = 'viewOnly'
}

export enum UserType {
  Community = 'community',
  Poweredby = 'poweredby',
  Pro = 'pro'
}

export type Venue = {
  __typename?: 'Venue';
  accessibilityDetails?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imagePath?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  location?: Maybe<VenueLocation>;
  phone?: Maybe<Scalars['String']['output']>;
  photographerLink?: Maybe<Scalars['String']['output']>;
  photographerName?: Maybe<Scalars['String']['output']>;
  showclixID?: Maybe<Scalars['Int']['output']>;
  stubHub?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type VenueInput = {
  accessibilityDetails?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imagePath?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<VenueLocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photographerLink?: InputMaybe<Scalars['String']['input']>;
  photographerName?: InputMaybe<Scalars['String']['input']>;
  poweredByAffiliates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  venueType?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type VenueLocation = {
  __typename?: 'VenueLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type VenueLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Waitlist = {
  __typename?: 'Waitlist';
  date?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum Weekday {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export type OrderSummaryEventQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type OrderSummaryEventQuery = { __typename?: 'Query', event?: { __typename?: 'EventObject', id: string, title: string, eventImage?: string | null, startDate?: any | null, endDate?: any | null, currency: string, timezone?: string | null, category?: EventCategory | null, place?: string | null, presentedBy?: boolean | null, presentedByName?: string | null, requirePurchaserAddress: boolean, status: EventStatus, shortEventId?: string | null, organizerType?: UserType | null, organizerColor?: string | null, organizerId?: string | null, eventCapacity?: number | null, additionalTerms?: string | null, fbpid?: string | null, overrideDateRange?: string | null, eventType?: string | null, suspension?: { __typename?: 'EventSuspension', indefinite?: boolean | null } | null, checkoutCustomFields?: Array<{ __typename?: 'CheckoutCustomField', id: string, label: string, maxLimit: number, minLimit: number }> | null, address?: { __typename?: 'EventAddress', formattedAddress?: string | null, businessName?: string | null, privateLocation?: boolean | null, customName?: string | null, street?: string | null, city?: string | null, region?: string | null } | null, addonCategories?: Array<{ __typename?: 'AddonCategoryObject', order: number, categoryId: string, name: string, description?: string | null, quantityMin?: number | null, quantityMax?: number | null, isQuantityMinStrict?: boolean | null, imageKey?: string | null, hashedUnlockCode?: Array<string> | null, unlockWith?: any | null, isHidden: boolean, forcePurchaseWithTicket: boolean, variations?: Array<{ __typename?: 'AddonVariationObject', order: number, variationId: string, name: string, description?: string | null, quantityLimit: number, enteredAmountDelta: number, quantityDistributed: { __typename?: 'AddonQuantityDistributed', inCart: number, distributed: number }, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null }> | null, ticketCategories?: Array<{ __typename?: 'TicketCategoryObject', categoryId: string, hashedUnlockCode?: Array<string> | null, isQuantityMinStrict?: boolean | null, name?: string | null, description?: string | null, inventory?: number | null, quantityIssued?: number | null, quantityLimit?: number | null, quantityMin?: number | null, quantityMax?: number | null, quantityDistributed?: number | null, visibility?: TicketCategoryVisibility | null, status?: string | null, ticketTag?: TicketTag | null, basePrice?: { __typename?: 'Money', amount: number, currency: string } | null, processingFee?: { __typename?: 'Money', amount: number, currency: string } | null, serviceFee?: { __typename?: 'Money', amount: number, currency: string } | null, unitPrice?: Array<{ __typename?: 'TicketCategoryUnitPrice', id?: string | null, name?: string | null, order?: number | null, charge?: { __typename?: 'Money', amount: number, currency: string } | null } | null> | null, conditions?: { __typename?: 'TicketCategoryConditionsObject', saleWindow?: { __typename?: 'TicketCategorySaleWindowObject', from?: any | null, fromDateVisible?: boolean | null, to?: any | null, toDateVisible?: boolean | null } | null } | null, pairedAddons?: Array<{ __typename?: 'AddonCategoryObject', categoryId: string, name: string, description?: string | null, imageKey?: string | null, isHidden: boolean, unlockWith?: any | null, variations?: Array<{ __typename?: 'AddonVariationObject', categoryId?: string | null, variationId: string, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null }> | null, flexiblePricing?: { __typename?: 'FlexiblePricingObject', minAmount: number, maxAmount: number, steps?: Array<number> | null, isDonation: boolean } | null, unlockCondition?: { __typename?: 'TicketCategoryUnlockCondition', dependsOn: string, amount: number, calculation: UnlockCalculationType } | null } | null> | null, questionnaire?: { __typename?: 'Questionnaire', id: any, version: number, questions: Array<{ __typename?: 'Question', ticketCategoryIds: Array<string> }> } | null, feesGroups?: Array<{ __typename?: 'FeesGroupObject', name: string, feeIds?: Array<string> | null }> | null, checkoutPromoCodes?: Array<{ __typename?: 'PromoCode', hashedPromoCode?: string | null, discountType: DiscountType, discountAmount?: number | null, startDate?: any | null, endDate?: any | null, minTicketsPerOrder?: number | null, maxTicketsPerOrder?: number | null, ticketTypes?: Array<string> | null } | null> | null } | null };

export type QuestionnairePageEventQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type QuestionnairePageEventQuery = { __typename?: 'Query', event?: { __typename?: 'EventObject', id: string, shortEventId?: string | null, organizerType?: UserType | null, organizerColor?: string | null, organizerId?: string | null, additionalTerms?: string | null, fbpid?: string | null, overrideDateRange?: string | null, eventType?: string | null, suspension?: { __typename?: 'EventSuspension', indefinite?: boolean | null } | null, ticketCategories?: Array<{ __typename?: 'TicketCategoryObject', categoryId: string, name?: string | null, unitPrice?: Array<{ __typename?: 'TicketCategoryUnitPrice', id?: string | null, name?: string | null, order?: number | null, charge?: { __typename?: 'Money', amount: number, currency: string } | null } | null> | null } | null> | null, addonCategories?: Array<{ __typename?: 'AddonCategoryObject', order: number, categoryId: string, name: string, description?: string | null, quantityMin?: number | null, quantityMax?: number | null, isQuantityMinStrict?: boolean | null, imageKey?: string | null, hashedUnlockCode?: Array<string> | null, unlockWith?: any | null, isHidden: boolean, forcePurchaseWithTicket: boolean, variations?: Array<{ __typename?: 'AddonVariationObject', order: number, variationId: string, name: string, description?: string | null, quantityLimit: number, enteredAmountDelta: number, quantityDistributed: { __typename?: 'AddonQuantityDistributed', inCart: number, distributed: number }, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null }> | null, questionnaire?: { __typename?: 'Questionnaire', id: any, version: number, questions: Array<{ __typename?: 'Question', text: string, type: QuestionType, ticketCategoryIds: Array<string>, isRequired: boolean, sequenceOrder: number, options?: Array<{ __typename?: 'QuestionOption', text: string }> | null }> } | null, checkoutPromoCodes?: Array<{ __typename?: 'PromoCode', hashedPromoCode?: string | null, discountType: DiscountType, discountAmount?: number | null, startDate?: any | null, endDate?: any | null, minTicketsPerOrder?: number | null, maxTicketsPerOrder?: number | null, ticketTypes?: Array<string> | null } | null> | null } | null };

export type AdditionTermsPageEventQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type AdditionTermsPageEventQuery = { __typename?: 'Query', event?: { __typename?: 'EventObject', id: string, shortEventId?: string | null, title: string, startDate?: any | null, endDate?: any | null, additionalTerms?: string | null, organizerType?: UserType | null, organizerColor?: string | null, currency: string, fbpid?: string | null, overrideDateRange?: string | null, eventType?: string | null, checkoutCustomFields?: Array<{ __typename?: 'CheckoutCustomField', id: string, label: string, maxLimit: number, minLimit: number }> | null, addonCategories?: Array<{ __typename?: 'AddonCategoryObject', order: number, categoryId: string, name: string, description?: string | null, quantityMin?: number | null, quantityMax?: number | null, isQuantityMinStrict?: boolean | null, imageKey?: string | null, hashedUnlockCode?: Array<string> | null, unlockWith?: any | null, isHidden: boolean, variations?: Array<{ __typename?: 'AddonVariationObject', order: number, variationId: string, name: string, description?: string | null, quantityLimit: number, enteredAmountDelta: number, quantityDistributed: { __typename?: 'AddonQuantityDistributed', inCart: number, distributed: number }, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null }> | null, ticketCategories?: Array<{ __typename?: 'TicketCategoryObject', categoryId: string, hashedUnlockCode?: Array<string> | null, isQuantityMinStrict?: boolean | null, name?: string | null, description?: string | null, quantityIssued?: number | null, quantityLimit?: number | null, quantityMin?: number | null, quantityMax?: number | null, visibility?: TicketCategoryVisibility | null, status?: string | null, ticketTag?: TicketTag | null, basePrice?: { __typename?: 'Money', amount: number, currency: string } | null, processingFee?: { __typename?: 'Money', amount: number, currency: string } | null, serviceFee?: { __typename?: 'Money', amount: number, currency: string } | null, unitPrice?: Array<{ __typename?: 'TicketCategoryUnitPrice', id?: string | null, name?: string | null, order?: number | null, charge?: { __typename?: 'Money', amount: number, currency: string } | null } | null> | null, conditions?: { __typename?: 'TicketCategoryConditionsObject', saleWindow?: { __typename?: 'TicketCategorySaleWindowObject', from?: any | null, fromDateVisible?: boolean | null, to?: any | null, toDateVisible?: boolean | null } | null } | null, pairedAddons?: Array<{ __typename?: 'AddonCategoryObject', categoryId: string, name: string, description?: string | null, imageKey?: string | null, isHidden: boolean, unlockWith?: any | null, variations?: Array<{ __typename?: 'AddonVariationObject', categoryId?: string | null, variationId: string, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null }> | null, flexiblePricing?: { __typename?: 'FlexiblePricingObject', minAmount: number, maxAmount: number, steps?: Array<number> | null, isDonation: boolean } | null } | null> | null, questionnaire?: { __typename?: 'Questionnaire', id: any, version: number, questions: Array<{ __typename?: 'Question', ticketCategoryIds: Array<string> }> } | null, checkoutPromoCodes?: Array<{ __typename?: 'PromoCode', hashedPromoCode?: string | null, discountType: DiscountType, discountAmount?: number | null, startDate?: any | null, endDate?: any | null, minTicketsPerOrder?: number | null, maxTicketsPerOrder?: number | null, ticketTypes?: Array<string> | null } | null> | null } | null };

export type PaymentPageEventQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type PaymentPageEventQuery = { __typename?: 'Query', event?: { __typename?: 'EventObject', id: string, title: string, eventImage?: string | null, startDate?: any | null, currency: string, endDate?: any | null, timezone?: string | null, place?: string | null, presentedBy?: boolean | null, presentedByName?: string | null, requirePurchaserAddress: boolean, shortEventId?: string | null, organizerType?: UserType | null, organizerColor?: string | null, additionalTerms?: string | null, fbpid?: string | null, overrideDateRange?: string | null, eventType?: string | null, checkoutCustomFields?: Array<{ __typename?: 'CheckoutCustomField', id: string, label: string, maxLimit: number, minLimit: number }> | null, suspension?: { __typename?: 'EventSuspension', indefinite?: boolean | null } | null, address?: { __typename?: 'EventAddress', formattedAddress?: string | null, businessName?: string | null, privateLocation?: boolean | null, customName?: string | null, street?: string | null, city?: string | null, region?: string | null } | null, addonCategories?: Array<{ __typename?: 'AddonCategoryObject', order: number, categoryId: string, name: string, description?: string | null, quantityMin?: number | null, quantityMax?: number | null, isQuantityMinStrict?: boolean | null, imageKey?: string | null, hashedUnlockCode?: Array<string> | null, isHidden: boolean, variations?: Array<{ __typename?: 'AddonVariationObject', order: number, variationId: string, name: string, description?: string | null, quantityLimit: number, quantityDistributed: { __typename?: 'AddonQuantityDistributed', inCart: number, distributed: number }, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null }> | null, ticketCategories?: Array<{ __typename?: 'TicketCategoryObject', categoryId: string, name?: string | null, hashedUnlockCode?: Array<string> | null, basePrice?: { __typename?: 'Money', amount: number, currency: string } | null, processingFee?: { __typename?: 'Money', amount: number, currency: string } | null, serviceFee?: { __typename?: 'Money', amount: number, currency: string } | null, unitPrice?: Array<{ __typename?: 'TicketCategoryUnitPrice', order?: number | null, id?: string | null, name?: string | null, charge?: { __typename?: 'Money', amount: number, currency: string } | null } | null> | null, flexiblePricing?: { __typename?: 'FlexiblePricingObject', minAmount: number, maxAmount: number, steps?: Array<number> | null, isDonation: boolean } | null } | null> | null, questionnaire?: { __typename?: 'Questionnaire', id: any, version: number, questions: Array<{ __typename?: 'Question', ticketCategoryIds: Array<string> }> } | null, feesGroups?: Array<{ __typename?: 'FeesGroupObject', name: string, feeIds?: Array<string> | null }> | null, checkoutPromoCodes?: Array<{ __typename?: 'PromoCode', hashedPromoCode?: string | null, discountType: DiscountType, discountAmount?: number | null, startDate?: any | null, endDate?: any | null, minTicketsPerOrder?: number | null, maxTicketsPerOrder?: number | null, ticketTypes?: Array<string> | null } | null> | null } | null };

export type ConfirmationPageEventQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type ConfirmationPageEventQuery = { __typename?: 'Query', event?: { __typename?: 'EventObject', id: string, title: string, description?: string | null, eventImage?: string | null, startDate?: any | null, timezone?: string | null, endDate?: any | null, place?: string | null, category?: EventCategory | null, presentedBy?: boolean | null, presentedByName?: string | null, shortEventId?: string | null, organizerType?: UserType | null, organizerColor?: string | null, currency: string, additionalTerms?: string | null, fbpid?: string | null, overrideDateRange?: string | null, eventType?: string | null, customFees?: Array<{ __typename?: 'CustomFeeObject', amountCents?: number | null, id?: string | null, name?: string | null, order?: number | null, percentRate?: string | null } | null> | null, suspension?: { __typename?: 'EventSuspension', indefinite?: boolean | null } | null, address?: { __typename?: 'EventAddress', formattedAddress?: string | null, businessName?: string | null, privateLocation?: boolean | null, customName?: string | null, street?: string | null, city?: string | null, region?: string | null } | null, addonCategories?: Array<{ __typename?: 'AddonCategoryObject', categoryId: string, name: string, description?: string | null, quantityMin?: number | null, quantityMax?: number | null, isQuantityMinStrict?: boolean | null, imageKey?: string | null, hashedUnlockCode?: Array<string> | null, isHidden: boolean, unlockWith?: any | null, order: number, forcePurchaseWithTicket: boolean, variations?: Array<{ __typename?: 'AddonVariationObject', order: number, variationId: string, name: string, description?: string | null, quantityLimit: number, quantityDistributed: { __typename?: 'AddonQuantityDistributed', inCart: number, distributed: number }, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null }> | null, ticketCategories?: Array<{ __typename?: 'TicketCategoryObject', categoryId: string, name?: string | null, unitPrice?: Array<{ __typename?: 'TicketCategoryUnitPrice', id?: string | null, name?: string | null, charge?: { __typename?: 'Money', amount: number, currency: string } | null } | null> | null, basePrice?: { __typename?: 'Money', amount: number, currency: string } | null, processingFee?: { __typename?: 'Money', amount: number, currency: string } | null, serviceFee?: { __typename?: 'Money', amount: number, currency: string } | null, flexiblePricing?: { __typename?: 'FlexiblePricingObject', minAmount: number, maxAmount: number, steps?: Array<number> | null, isDonation: boolean } | null } | null> | null, postCheckoutCta?: { __typename?: 'PostCheckoutCta', text: string, link: string } | null, questionnaire?: { __typename?: 'Questionnaire', id: any, version: number, questions: Array<{ __typename?: 'Question', ticketCategoryIds: Array<string> }> } | null, checkoutPromoCodes?: Array<{ __typename?: 'PromoCode', hashedPromoCode?: string | null, discountType: DiscountType, discountAmount?: number | null, startDate?: any | null, endDate?: any | null, minTicketsPerOrder?: number | null, maxTicketsPerOrder?: number | null, ticketTypes?: Array<string> | null } | null> | null } | null };

export type GetFacebookPixelIdQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type GetFacebookPixelIdQuery = { __typename?: 'Query', event?: { __typename?: 'EventObject', id: string, fbpid?: string | null } | null };

export type CalculateFlexibleTicketPriceQueryVariables = Exact<{
  eventId: Scalars['ObjectID']['input'];
  categoryId: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
}>;


export type CalculateFlexibleTicketPriceQuery = { __typename?: 'Query', calculateFlexibleTicketPrice?: Array<{ __typename?: 'TicketCategoryUnitPrice', id?: string | null, order?: number | null, name?: string | null, charge?: { __typename?: 'Money', amount: number, currency: string } | null }> | null };

export type DeleteHoldMutationVariables = Exact<{
  deleteHoldId: Scalars['ObjectID']['input'];
  addToInventory: Scalars['Boolean']['input'];
}>;


export type DeleteHoldMutation = { __typename?: 'Mutation', deleteHold: boolean };

export type CreateHoldMutationVariables = Exact<{
  payload: CreateHoldInput;
}>;


export type CreateHoldMutation = { __typename?: 'Mutation', createHold?: { __typename?: 'HoldOutput', id: string, expiresAt: any } | null };

export type DownloadTicketsMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type DownloadTicketsMutation = { __typename?: 'Mutation', downloadTicketsAtConfirmation?: string | null };

export type CreateCheckoutSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'CheckoutSession', sessionToken: string } | null };

export type CreateOrderMutationVariables = Exact<{
  payload: CreateInternalOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createInternalOrder?: string | null };

export type DownloadAdditionalTermsMutationVariables = Exact<{
  shortOrderId: Scalars['String']['input'];
}>;


export type DownloadAdditionalTermsMutation = { __typename?: 'Mutation', downloadAdditionalTermsAtConfirmation?: string | null };

export type AnswersQuestionnaireMutationVariables = Exact<{
  orderShortId: Scalars['String']['input'];
  submissionInput: QuestionnaireSubmissionInput;
}>;


export type AnswersQuestionnaireMutation = { __typename?: 'Mutation', submitQuestionnaireAnswers?: { __typename?: 'QuestionnaireSubmission', questionnaireVersion: number } | null };

export type AddonCategoryFragment = { __typename?: 'AddonCategoryObject', categoryId: string, name: string, description?: string | null, quantityMin?: number | null, quantityMax?: number | null, isQuantityMinStrict?: boolean | null, imageKey?: string | null, hashedUnlockCode?: Array<string> | null, isHidden: boolean, unlockWith?: any | null, order: number, forcePurchaseWithTicket: boolean, variations?: Array<{ __typename?: 'AddonVariationObject', order: number, variationId: string, name: string, description?: string | null, quantityLimit: number, quantityDistributed: { __typename?: 'AddonQuantityDistributed', inCart: number, distributed: number }, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> }> | null };

export type AddonVariationFragment = { __typename?: 'AddonVariationObject', variationId: string, name: string, description?: string | null, quantityLimit: number, quantityDistributed: { __typename?: 'AddonQuantityDistributed', inCart: number, distributed: number }, unitPrice: Array<{ __typename?: 'AddonVariationUnitPrice', order: number, id: string, name: string, charge: { __typename?: 'Money', amount: number, currency: string } }> };

export const AddonCategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddonCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddonCategoryObject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"unlockWith"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"forcePurchaseWithTicket"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inCart"}},{"kind":"Field","name":{"kind":"Name","value":"distributed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddonCategoryFragment, unknown>;
export const AddonVariationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddonVariation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddonVariationObject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inCart"}},{"kind":"Field","name":{"kind":"Name","value":"distributed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<AddonVariationFragment, unknown>;
export const OrderSummaryEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderSummaryEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventImage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"presentedBy"}},{"kind":"Field","name":{"kind":"Name","value":"presentedByName"}},{"kind":"Field","name":{"kind":"Name","value":"requirePurchaserAddress"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"suspension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indefinite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkoutCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"maxLimit"}},{"kind":"Field","name":{"kind":"Name","value":"minLimit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"privateLocation"}},{"kind":"Field","name":{"kind":"Name","value":"customName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortEventId"}},{"kind":"Field","name":{"kind":"Name","value":"organizerType"}},{"kind":"Field","name":{"kind":"Name","value":"organizerColor"}},{"kind":"Field","name":{"kind":"Name","value":"organizerId"}},{"kind":"Field","name":{"kind":"Name","value":"eventCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"addonCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"unlockWith"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"forcePurchaseWithTicket"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inCart"}},{"kind":"Field","name":{"kind":"Name","value":"distributed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enteredAmountDelta"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"donationsFilter"},"value":{"kind":"EnumValue","value":"with"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"processingFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"}},{"kind":"Field","name":{"kind":"Name","value":"quantityIssued"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"}},{"kind":"Field","name":{"kind":"Name","value":"serviceFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saleWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"fromDateVisible"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"toDateVisible"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketTag"}},{"kind":"Field","name":{"kind":"Name","value":"pairedAddons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"unlockWith"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flexiblePricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"steps"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unlockCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dependsOn"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"calculation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalTerms"}},{"kind":"Field","name":{"kind":"Name","value":"fbpid"}},{"kind":"Field","name":{"kind":"Name","value":"overrideDateRange"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"questionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketCategoryIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feesGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkoutPromoCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashedPromoCode"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"minTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"maxTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"ticketTypes"}}]}}]}}]}}]} as unknown as DocumentNode<OrderSummaryEventQuery, OrderSummaryEventQueryVariables>;
export const QuestionnairePageEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuestionnairePageEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortEventId"}},{"kind":"Field","name":{"kind":"Name","value":"suspension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indefinite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizerType"}},{"kind":"Field","name":{"kind":"Name","value":"organizerColor"}},{"kind":"Field","name":{"kind":"Name","value":"organizerId"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"donationsFilter"},"value":{"kind":"EnumValue","value":"with"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"addonCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"unlockWith"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"forcePurchaseWithTicket"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inCart"}},{"kind":"Field","name":{"kind":"Name","value":"distributed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enteredAmountDelta"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalTerms"}},{"kind":"Field","name":{"kind":"Name","value":"fbpid"}},{"kind":"Field","name":{"kind":"Name","value":"overrideDateRange"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"questionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"ticketCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sequenceOrder"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkoutPromoCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashedPromoCode"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"minTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"maxTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"ticketTypes"}}]}}]}}]}}]} as unknown as DocumentNode<QuestionnairePageEventQuery, QuestionnairePageEventQueryVariables>;
export const AdditionTermsPageEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdditionTermsPageEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortEventId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalTerms"}},{"kind":"Field","name":{"kind":"Name","value":"organizerType"}},{"kind":"Field","name":{"kind":"Name","value":"organizerColor"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"checkoutCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"maxLimit"}},{"kind":"Field","name":{"kind":"Name","value":"minLimit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addonCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"unlockWith"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inCart"}},{"kind":"Field","name":{"kind":"Name","value":"distributed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enteredAmountDelta"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"donationsFilter"},"value":{"kind":"EnumValue","value":"with"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"processingFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantityIssued"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"serviceFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saleWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"fromDateVisible"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"toDateVisible"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketTag"}},{"kind":"Field","name":{"kind":"Name","value":"pairedAddons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"unlockWith"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"flexiblePricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"steps"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fbpid"}},{"kind":"Field","name":{"kind":"Name","value":"overrideDateRange"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"questionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketCategoryIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkoutPromoCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashedPromoCode"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"minTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"maxTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"ticketTypes"}}]}}]}}]}}]} as unknown as DocumentNode<AdditionTermsPageEventQuery, AdditionTermsPageEventQueryVariables>;
export const PaymentPageEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentPageEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"eventImage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"presentedBy"}},{"kind":"Field","name":{"kind":"Name","value":"presentedByName"}},{"kind":"Field","name":{"kind":"Name","value":"requirePurchaserAddress"}},{"kind":"Field","name":{"kind":"Name","value":"checkoutCustomFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"maxLimit"}},{"kind":"Field","name":{"kind":"Name","value":"minLimit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suspension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indefinite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"privateLocation"}},{"kind":"Field","name":{"kind":"Name","value":"customName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortEventId"}},{"kind":"Field","name":{"kind":"Name","value":"organizerType"}},{"kind":"Field","name":{"kind":"Name","value":"organizerColor"}},{"kind":"Field","name":{"kind":"Name","value":"addonCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inCart"}},{"kind":"Field","name":{"kind":"Name","value":"distributed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"donationsFilter"},"value":{"kind":"EnumValue","value":"with"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processingFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"flexiblePricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"steps"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalTerms"}},{"kind":"Field","name":{"kind":"Name","value":"fbpid"}},{"kind":"Field","name":{"kind":"Name","value":"overrideDateRange"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"questionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketCategoryIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"feesGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkoutPromoCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashedPromoCode"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"minTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"maxTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"ticketTypes"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentPageEventQuery, PaymentPageEventQueryVariables>;
export const ConfirmationPageEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfirmationPageEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"eventImage"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"place"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"presentedBy"}},{"kind":"Field","name":{"kind":"Name","value":"presentedByName"}},{"kind":"Field","name":{"kind":"Name","value":"customFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountCents"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"percentRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suspension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indefinite"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"privateLocation"}},{"kind":"Field","name":{"kind":"Name","value":"customName"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortEventId"}},{"kind":"Field","name":{"kind":"Name","value":"organizerType"}},{"kind":"Field","name":{"kind":"Name","value":"organizerColor"}},{"kind":"Field","name":{"kind":"Name","value":"addonCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddonCategory"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticketCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"donationsFilter"},"value":{"kind":"EnumValue","value":"with"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processingFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceFee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flexiblePricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"steps"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"postCheckoutCta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalTerms"}},{"kind":"Field","name":{"kind":"Name","value":"fbpid"}},{"kind":"Field","name":{"kind":"Name","value":"overrideDateRange"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"questionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketCategoryIds"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkoutPromoCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashedPromoCode"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"minTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"maxTicketsPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"ticketTypes"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddonCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddonCategoryObject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMin"}},{"kind":"Field","name":{"kind":"Name","value":"quantityMax"}},{"kind":"Field","name":{"kind":"Name","value":"isQuantityMinStrict"}},{"kind":"Field","name":{"kind":"Name","value":"imageKey"}},{"kind":"Field","name":{"kind":"Name","value":"hashedUnlockCode"}},{"kind":"Field","name":{"kind":"Name","value":"isHidden"}},{"kind":"Field","name":{"kind":"Name","value":"unlockWith"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"forcePurchaseWithTicket"}},{"kind":"Field","name":{"kind":"Name","value":"variations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"variationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantityLimit"}},{"kind":"Field","name":{"kind":"Name","value":"quantityDistributed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inCart"}},{"kind":"Field","name":{"kind":"Name","value":"distributed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmationPageEventQuery, ConfirmationPageEventQueryVariables>;
export const GetFacebookPixelIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFacebookPixelId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fbpid"}}]}}]}}]} as unknown as DocumentNode<GetFacebookPixelIdQuery, GetFacebookPixelIdQueryVariables>;
export const CalculateFlexibleTicketPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalculateFlexibleTicketPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculateFlexibleTicketPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"Argument","name":{"kind":"Name","value":"categoryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<CalculateFlexibleTicketPriceQuery, CalculateFlexibleTicketPriceQueryVariables>;
export const DeleteHoldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteHold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteHoldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjectID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addToInventory"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteHold"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteHoldId"}}},{"kind":"Argument","name":{"kind":"Name","value":"addToInventory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addToInventory"}}}]}]}}]} as unknown as DocumentNode<DeleteHoldMutation, DeleteHoldMutationVariables>;
export const CreateHoldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateHold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateHoldInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createHold"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<CreateHoldMutation, CreateHoldMutationVariables>;
export const DownloadTicketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadTickets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadTicketsAtConfirmation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shortOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}]}}]} as unknown as DocumentNode<DownloadTicketsMutation, DownloadTicketsMutationVariables>;
export const CreateCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCheckoutSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCheckoutSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]} as unknown as DocumentNode<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateInternalOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInternalOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payload"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payload"}}}]}]}}]} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const DownloadAdditionalTermsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadAdditionalTerms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadAdditionalTermsAtConfirmation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shortOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortOrderId"}}}]}]}}]} as unknown as DocumentNode<DownloadAdditionalTermsMutation, DownloadAdditionalTermsMutationVariables>;
export const AnswersQuestionnaireDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AnswersQuestionnaire"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderShortId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionnaireSubmissionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitQuestionnaireAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderShortId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderShortId"}}},{"kind":"Argument","name":{"kind":"Name","value":"submissionInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionnaireVersion"}}]}}]}}]} as unknown as DocumentNode<AnswersQuestionnaireMutation, AnswersQuestionnaireMutationVariables>;